import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  TableCell,
  TableRow,
  Typography,
  Tabs,
  Tab,
  Button,
  Alert,
  Chip,
} from "@mui/material";
import { FC, useEffect, useState, useCallback, useRef } from "react";
import FormField from "../../../../components/common/FormField";
import {
  leadAncillariesFields,
  leadAncillariesHeading,
  leadChargesFields,
  leadChargesHeading,
  getLeadEstimateFinalFields,
  leadEstimateInsuranceFields,
  leadEstimateInsuranceGeneralFields,
  leadGenInfoFields,
  leadGenInfoHeading,
  leadGenInoList,
  leadMaterialsFields,
  leadMaterialsHeading,
  leadQuoteNoteFields,
  leadQuoteSubcontractorFields,
  leadQuoteSubcontractorHeading,
  leadEstimateFinalFields,
} from "../leadAllFields";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  addLeadQuoteAction,
  deleteSingleLeadQuoteAction,
  getLeadEstimateAction,
  setLeadEstimateAction,
} from "../../../../store/reducers/leadSlice";
import { leadQuoteInitial } from "../../../../store/reducers/leadUtils";
import {
  getAllVehicles,
  getFuelDetails,
  getVehicleTypes,
} from "../../../../store/reducers/vehicleSlice";
import {
  calculateProfit,
  estimateChangeAction,
  estimateValidateForm,
  getTotal,
} from "./leadEstimateUtil";
import RenderEstimateTable from "./RenderEstimateTable";
import useStyles from "./leadEstimateStyle";

import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import {
  leadEstimateMaterialsFields,
  leadEstimateMaterialsHeading,
  leadEstimateNewFinalFields,
} from "../estimateAllFields";
import { getGeneralInformationAction } from "../../../../store/reducers/documentSlice";
import Notification from "../../../../components/common/notification/Notification";

import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import { getLeadColor } from "../../customerInvoice/InvoiceUntil";
import QuoteActions from "./QuoteActions";
import LeadDetailSection from "../estimate/LeadDetailSection";
import { getAllSubContractorAction } from "../../../../store/reducers/subContractor";
import { getAllMaterialAction } from "../../../../store/reducers/materialSlice";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";
import AlertMessage from "./AlertMessage";
import { getAllSaleAction } from "../../../../store/reducers/saleSlice";
import dayjs from "dayjs";
import { getFinancialAction } from "../../../../store/reducers/quickBookSlice";
import { DeleteOutlined } from "@mui/icons-material";
import {
  leadProfessionalChargesFields,
  leadProfessionalChargesHeading,
} from "./quoteAllFields";
import { getDefaultServiceListAction } from "../../../../store/reducers/reviewSlice";
import {
  getBaseServiceType as getBaseServiceTypeHelper,
  getUniqueServiceType as getUniqueServiceTypeHelper,
} from "../serviceTypeUtils";

// Normalize service/type names for consistent logic
function normalizeServiceName(name: string) {
  if (!name) return "";
  const n = name.trim().toLowerCase();
  if (n === "full pack" || n === "full packing") return "Full Packing";
  if (
    n === "removal" ||
    n === "removal, door to door" ||
    n === "removal door to door" ||
    n === "door to door"
  )
    return "Removal, Door to Door";
  return name;
}

function getServiceTypeKey(name: any) {
  return String(normalizeServiceName(String(name || "")))
    .toLowerCase()
    .replace(/[\s,_-]+/g, "");
}

// Utility to calculate provisionalDate
function calculateProvisionalDate(
  service: any,
  services: any,
  leadDetails: any,
) {
  if (!service || !leadDetails?.lead) return null;
  if (
    leadDetails.lead.moving_on_date &&
    service.day !== null &&
    service.day !== undefined &&
    Number(service.day) !== 0
  ) {
    const baseDay = Number(services?.[0]?.day) || 2;
    const offset = Number(service.day) - baseDay;
    return require("dayjs")(leadDetails.lead.moving_on_date)
      .add(offset, "day")
      .format("YYYY-MM-DD");
  } else if (leadDetails.lead.packing_on_date) {
    return require("dayjs")(leadDetails.lead.packing_on_date).format(
      "YYYY-MM-DD",
    );
  }
  return null;
}

const LeadQuoteForm: FC<any> = ({ show, setShow, screenType }) => {
  // State for duplicate alert modal
  const [showDuplicateAlert, setShowDuplicateAlert] = useState(false);
  // Store pending change to apply after duplication
  const pendingChangeRef = useRef<any>(null);
  const [load, setLoad] = useState(false);
  const classes = useStyles({ show, load });

  // Tab management state
  const [activeTab, setActiveTab] = useState(0);
  const [quoteTabs, setQuoteTabs] = useState([
    { id: 0, label: "Quote 1", data: null, error: null },
  ]);
  const lastSavedTabRef = useRef<number>(0); // Track the last saved/active tab
  const lastInsuranceCalcRemovalPriceRef = useRef<number | null>(null);

  const [estimateForm, setEstimateForm]: any = useState(null);
  const [error, setError] = useState<any>(null);
  const [vehiclesOptions, setVehiclesOptions] = useState([]);
  const [subContractorOptions, setSubContractorOptions] = useState([]);
  const [disabledField, setDisabledField] = useState(false);
  const [chargesError, setChargesError] = useState(false);
  const [costChargeError, setCostChargeError] = useState(false);
  const [isFieldValueChanged, setIsFieldValueChanged] = useState(false);
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [showAcceptedQuoteAlert, setShowAcceptedQuoteAlert] = useState(false);
  const [showCloseConfirmDialog, setShowCloseConfirmDialog] = useState(false);
  const [showNewQuoteConfirmDialog, setShowNewQuoteConfirmDialog] =
    useState(false);
  const [tabToDelete, setTabToDelete] = useState<number | null>(null);
  const [isTesterSection, setIsTesterSection] = useState(true);
  const { leadDetails, selectedLeadQuote } = useSelector(
    (state: any) => state.lead,
  );
  const { genenralInfoData } = useSelector((state: any) => state.document);
  const { vehicles, vehicleTypes, fuelDetails } = useSelector(
    (state: any) => state.vehicle,
  );
  const { defaultServiceList = [] } = useSelector((state: any) => state.review);
  const { userProfile } = useSelector((state: any) => state?.user);
  const { subContractors } = useSelector((state: any) => state.subContractor);
  const { materials } = useSelector((state: any) => state.material);
  const { sales } = useSelector((state: any) => state.sale);
  const { newFinancialState } = useSelector((state: any) => state.quickBook);
  const [isCostSection, setIsCostSection] = useState(
    true,
    // userProfile?.features?.includes("Cost") || false // Safe fallback
  );

  const [isAnciliarySection, setIsAnciliarySection] = useState(
    true,
    // userProfile?.features?.includes("Ancillary") || false
  );
  const [isFullMaterialList, setIsFullMaterial] = useState(
    true,
    // userProfile?.features?.includes("Full Material List") || false
  );

  useEffect(() => {
    setIsTesterSection(
      userProfile?.features?.includes("Basic Work Diary") || false,
    );
    setIsCostSection(
      true,
      // userProfile?.features?.includes("Cost") || false
    ); // Sync profile changes
    setIsAnciliarySection(
      userProfile?.features?.includes("Ancillary") || false,
    );
    setIsFullMaterial(
      userProfile?.features?.includes("Full Material List") || false,
    );
  }, [userProfile]);

  const dispatch = useDispatch();

  const normalizeDropdownServiceName = (service: any) =>
    String(
      service?.name ||
        service?.typeName ||
        service?.service_name ||
        service?.type ||
        "",
    )
      .toLowerCase()
      .replace(/[,_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const normalizeDropdownServiceType = (service: any) =>
    String(service?.type || service?.service_name || service?.typeName || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[,_-]+/g, "");

  const getBaseDropdownServiceType = (serviceType: string) =>
    getBaseServiceTypeHelper(serviceType);

  const getOrderedServiceOptions = (services: any[] = []) => {
    const mappedServices = services
      .map((service: any) => ({
        id:
          service?.name ||
          service?.typeName ||
          service?.service_name ||
          service?.type ||
          "",
        name:
          service?.name ||
          service?.typeName ||
          service?.service_name ||
          service?.type ||
          "",
        description: service?.description || "",
        type:
          service?.type ||
          service?.service_name ||
          service?.typeName ||
          service?.name ||
          "",
        normalizedName: normalizeDropdownServiceName(service),
        typeKey: normalizeDropdownServiceType(service),
        orderIndex:
          service?.order_index !== undefined && service?.order_index !== null
            ? Number(service.order_index)
            : null,
      }))
      .filter((service: any) => !!service?.name);

    mappedServices.sort(
      (a: any, b: any) => (a.orderIndex || 999) - (b.orderIndex || 999),
    );

    const removalService = mappedServices.find((service: any) => {
      const key = service?.typeKey || normalizeDropdownServiceType(service);
      return key === "removal" || key === "removaltype";
    });

    const fullPackService = mappedServices.find(
      (service: any) =>
        (service?.typeKey || normalizeDropdownServiceType(service)) ===
        "fullpack",
    );

    const remainingServices = mappedServices.filter(
      (service: any) =>
        service !== removalService &&
        service !== fullPackService &&
        (service?.typeKey || normalizeDropdownServiceType(service)) !==
          "removal" &&
        (service?.typeKey || normalizeDropdownServiceType(service)) !==
          "removaltype" &&
        (service?.typeKey || normalizeDropdownServiceType(service)) !==
          "fullpack",
    );

    const orderedServiceOptions = [
      ...(removalService ? [removalService] : []),
      ...(fullPackService ? [fullPackService] : []),
      ...remainingServices,
    ];

    return orderedServiceOptions;
  };

  const serviceNameOptions = getOrderedServiceOptions(defaultServiceList);

  const getServiceOptionBySavedValue = (value: any) => {
    const savedName = normalizeDropdownServiceName({ name: value });
    const baseType = getBaseDropdownServiceType(String(value || ""));

    return serviceNameOptions.find((option: any) => {
      const optionName = normalizeDropdownServiceName(option);
      const optionType = getBaseDropdownServiceType(option?.type || "");
      return optionName === savedName || (baseType && optionType === baseType);
    });
  };

  // Build a dropdown option list that includes any saved service typeName
  // which no longer exists in the current defaultServiceList (renamed/deleted service).
  // Without this, old saved quotes show a BLANK dropdown even though valid data exists.
  const getMergedServiceOptions = (services: any[] = []) => {
    const existingKeys = new Set(
      serviceNameOptions.map((opt: any) => normalizeDropdownServiceName(opt)),
    );
    const orphanOptions: any[] = [];
    const seenOrphans = new Set<string>();

    (services || []).forEach((service: any) => {
      const savedName =
        service?.typeName || service?.type || service?.service_name;
      if (!savedName) return;

      const matched = getServiceOptionBySavedValue(savedName);
      if (matched) return; // already present in serviceNameOptions, no need to inject

      const key = normalizeDropdownServiceName({ name: savedName });
      if (existingKeys.has(key) || seenOrphans.has(key)) return;
      seenOrphans.add(key);

      // Inject the saved value itself as a valid option so the Select can match it
      orphanOptions.push({
        id: savedName,
        name: savedName,
        description: service?.description || "",
        type: service?.type || savedName,
      });
    });

    return [...serviceNameOptions, ...orphanOptions];
  };

  const getUniqueServiceType = (
    baseType: string,
    rowIndex: number,
    services: any[] = [],
  ) => getUniqueServiceTypeHelper(baseType, rowIndex, services);

  const getTotalDistanceMiles = useCallback(() => {
    const collectionAddresses = leadDetails?.lead?.collection_address || [];
    const deliveryAddresses = leadDetails?.lead?.delivery_address || [];

    const collectionDistance = collectionAddresses.reduce(
      (acc: number, curr: any) => acc + Number(curr?.distance || 0),
      0,
    );
    const deliveryDistance = deliveryAddresses.reduce(
      (acc: number, curr: any) => acc + Number(curr?.distance || 0),
      0,
    );
    const returningDistance = Number(
      leadDetails?.lead?.returning_distance || 0,
    );

    return collectionDistance + deliveryDistance + returningDistance;
  }, [leadDetails]);

  const getFuelRatePerLiter = useCallback(
    (fuelType: string) => {
      const normalizedFuelType = (fuelType || "").toLowerCase();
      if (normalizedFuelType === "diesel") {
        return Number(fuelDetails?.diesel_rate || 0);
      }
      if (normalizedFuelType === "petrol") {
        return Number(fuelDetails?.petrol_rate || 0);
      }
      if (normalizedFuelType === "electric") {
        return Number(fuelDetails?.electric_rate || 0);
      }
      // Hybrid fallback to petrol rate if a dedicated hybrid rate is not available.
      if (normalizedFuelType === "hybrid") {
        return Number(fuelDetails?.petrol_rate || 0);
      }
      return 0;
    },
    [fuelDetails],
  );

  const getDefaultServicesForQuote = useCallback(() => {
    if (!Array.isArray(defaultServiceList) || defaultServiceList.length === 0) {
      const baseServices = JSON.parse(
        JSON.stringify(leadQuoteInitial.services || []),
      );
      return baseServices.map((service: any, idx: number, arr: any[]) => ({
        ...service,
        provisionalDate: calculateProvisionalDate(service, arr, leadDetails),
      }));
    }

    const normalizeKey = (value: any) =>
      String(value || "")
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/[,_-]+/g, "");

    const isRemovalService = (service: any) => {
      const typeKey = normalizeKey(service?.type);
      const nameKey = normalizeKey(service?.typeName || service?.service_name);
      return (
        typeKey === "removal" ||
        typeKey === "removaldoortodoor" ||
        typeKey === "doortodoor" ||
        nameKey === "removal" ||
        nameKey === "removaldoortodoor" ||
        nameKey === "doortodoor"
      );
    };

    const isFullPackService = (service: any) => {
      const typeKey = normalizeKey(service?.type);
      const nameKey = normalizeKey(service?.typeName || service?.service_name);
      return (
        typeKey === "fullpack" ||
        typeKey === "fullpacking" ||
        nameKey === "fullpack" ||
        nameKey === "fullpacking"
      );
    };

    const mappedServices = defaultServiceList
      .map((service: any, index: number) => {
        const serviceName =
          service?.name || service?.type_name || service?.service_name || "";

        return {
          typeName: serviceName,
          type: service?.type,
          service_name: service?.service_name,
          description: service?.description || "",
          price: null,
          isAccepted: !!service?.is_accepted,
          day: null,
          provisionalDate: null,
          driverQty: null,
          porterQty: null,
          packerQty: null,
          vehicles: [
            {
              orderIndex: 1,
              vehicleQty: null,
              vehicleTypeId: "",
              fuelCharge: null,
            },
          ],
          wageCharge: null,
          orderIndex:
            service?.order_index !== null && service?.order_index !== undefined
              ? Number(service.order_index)
              : index + 1,
        };
      })
      .sort((a: any, b: any) => {
        const aOrder = Number.isFinite(Number(a?.orderIndex))
          ? Number(a.orderIndex)
          : Number.MAX_SAFE_INTEGER;
        const bOrder = Number.isFinite(Number(b?.orderIndex))
          ? Number(b.orderIndex)
          : Number.MAX_SAFE_INTEGER;
        return aOrder - bOrder;
      });

    const removalService = mappedServices.find((service: any) =>
      isRemovalService(service),
    );
    const fullPackService = mappedServices.find((service: any) =>
      isFullPackService(service),
    );
    const remainingServices = mappedServices.filter(
      (service: any) =>
        !isRemovalService(service) && !isFullPackService(service),
    );

    return [
      ...(removalService ? [removalService] : []),
      ...(fullPackService ? [fullPackService] : []),
      ...remainingServices,
    ].map((service: any, idx: number, arr: any[]) => ({
      ...service,
      orderIndex: idx + 1,
      day: idx === 0 && isRemovalService(service) ? 1 : null,
      provisionalDate: calculateProvisionalDate(service, arr, leadDetails),
    }));
  }, [defaultServiceList, leadDetails]);

  useEffect(() => {
    dispatch(
      getAllSubContractorAction({
        page: 1,
        limit: 100,
        orderBy: "created_at",
        orderIn: "DESC",
      }),
    );
    dispatch(getFinancialAction());
  }, []);

  // Reset tabs when modal opens/closes
  useEffect(() => {
    if (!show) {
      // Reset to initial state when modal closes
      setQuoteTabs([{ id: 0, label: "Quote 1", data: null, error: null }]);
      setActiveTab(0);
      setEstimateForm(null);
      setError(null);
      setIsFieldValueChanged(false);
      setShowNewQuoteConfirmDialog(false);
      setShowCloseConfirmDialog(false);
      lastSavedTabRef.current = 0; // Reset saved tab reference
    }
  }, [show]);

  useEffect(() => {
    if (screenType !== "quotation") {
      if (
        leadDetails?.lead?.status &&
        ((leadDetails?.lead?.status !== "NEW" &&
          leadDetails?.lead?.status !== "NEW LEAD" &&
          leadDetails?.lead?.status !== "ESTIMATES") ||
          leadDetails?.lead?.status === "COMPLETED" ||
          leadDetails?.lead?.status === "DEBTOR" ||
          leadDetails?.lead?.status === "EXTERNAL")
      ) {
        setDisabledField(true);
      } else {
        setDisabledField(false);
      }
    } else {
      if (
        leadDetails?.lead?.status &&
        (leadDetails?.lead?.status === "COMPLETED" ||
          // leadDetails?.lead?.status === "JOB" ||
          leadDetails?.lead?.status === "DEBTOR" ||
          leadDetails?.lead?.status === "EXTERNAL")
      ) {
        setDisabledField(true);
      } else if (
        estimateForm?.accepted_status?.toLowerCase() === "accepted" &&
        estimateForm?.hasFinalInvoice === true
      ) {
        setDisabledField(true);
      } else {
        setDisabledField(false);
      }
    }
  }, [leadDetails, screenType, estimateForm?.accepted_status]);

  useEffect(() => {
    if (
      selectedLeadQuote &&
      selectedLeadQuote.quotes &&
      selectedLeadQuote.quotes.length > 0
    ) {
      // Handle the quotes array structure
      const quotesArray = selectedLeadQuote.quotes;

      // Create tabs for each quote
      const newTabs = quotesArray.map((quote: any, index: number) => {
        const quoteData = JSON.parse(JSON.stringify(quote));

        // If quoteExpiresOn is missing or empty, calculate it based on created_at or current date
        if (!quoteData.quoteExpiresOn || quoteData.quoteExpiresOn === "") {
          const expiryDays = Number(sales?.quote_expiry_days) || 90;
          // Use created_at if available and valid, otherwise use current date
          const baseDate =
            quoteData.created_at && quoteData.created_at !== ""
              ? dayjs(quoteData.created_at)
              : dayjs();
          quoteData.quoteExpiresOn = baseDate
            .add(expiryDays, "days")
            .toISOString();
        }

        // If insuranceType is missing or empty, set default "Goods value" and its ID
        if (!quoteData.insuranceType || quoteData.insuranceType === "") {
          quoteData.insuranceType = "Goods value";
          // Also set the insurance_type_id if available
          if (sales?.insurance_extended_liability_types?.length > 0) {
            const defaultInsuranceType =
              sales.insurance_extended_liability_types.find(
                (type: any) => type.name === "Goods value",
              );
            if (defaultInsuranceType) {
              quoteData.insurance_type_id = defaultInsuranceType.id;
            }
          }
        }

        // -----------------------------
        // VAT Handling
        // -----------------------------
        if (quoteData?.quoteId === undefined || quoteData?.quoteId === null) {
          quoteData.vatIncluded = newFinancialState?.is_vat_included ?? false;
        }

        // If API returns no services for a quote, seed with default service list.
        if (
          !Array.isArray(quoteData.services) ||
          quoteData.services.length === 0
        ) {
          quoteData.services = getDefaultServicesForQuote();
        }

        // Ensure all services have a vehicles array (initialize if null)
        if (Array.isArray(quoteData.services)) {
          quoteData.services = quoteData.services.map(
            (service: any, idx: number, arr: any[]) => {
              const hasValidVehicles =
                Array.isArray(service.vehicles) && service.vehicles.length > 0;
              let updatedService = service;
              if (!hasValidVehicles || service.vehicles === null) {
                updatedService = {
                  ...service,
                  vehicles: [
                    {
                      orderIndex: 0,
                      vehicleQty: null,
                      vehicleTypeId: "",
                      fuelCharge: null,
                    },
                  ],
                };
              } else {
                // Preserve API-saved fuel charges from being auto-overwritten on initial render.
                updatedService = {
                  ...service,
                  vehicles: service.vehicles.map((vehicle: any) => {
                    const hasSavedFuelCharge =
                      vehicle?.fuelCharge !== null &&
                      vehicle?.fuelCharge !== undefined &&
                      vehicle?.fuelCharge !== "";
                    return {
                      ...vehicle,
                      isFuelChargeManual:
                        typeof vehicle?.isFuelChargeManual === "boolean"
                          ? vehicle.isFuelChargeManual
                          : hasSavedFuelCharge,
                    };
                  }),
                };
              }

              // ✅ NEW: Normalize typeName casing to exactly match an option's id/name.
              // Without this, MUI Select can't match "into store" (raw saved value)
              // against option "Into Store" (case-sensitive match), so dropdown shows blank.
              const matchedOption = getServiceOptionBySavedValue(
                updatedService?.typeName ?? updatedService?.type,
              );
              if (
                matchedOption &&
                updatedService.typeName !== matchedOption.name
              ) {
                updatedService = {
                  ...updatedService,
                  typeName: matchedOption.name,
                };
              }

              // Always set provisionalDate using calculateProvisionalDate
              return {
                ...updatedService,
                provisionalDate: calculateProvisionalDate(
                  updatedService,
                  arr,
                  leadDetails,
                ),
              };
            },
          );
        }

        // If generalInfo values are missing/null, fill with defaults from genenralInfoData
        if (quoteData.generalInfo && genenralInfoData?.id) {
          const hasNoValues =
            (quoteData.generalInfo.driverWage === null ||
              quoteData.generalInfo.driverWage === undefined) &&
            (quoteData.generalInfo.porterWage === null ||
              quoteData.generalInfo.porterWage === undefined) &&
            (quoteData.generalInfo.packerWage === null ||
              quoteData.generalInfo.packerWage === undefined);

          if (hasNoValues) {
            quoteData.generalInfo = {
              ...quoteData.generalInfo,
              driverWage:
                quoteData.generalInfo.driverWage ??
                (genenralInfoData.driver_wage != null
                  ? Number(genenralInfoData.driver_wage)
                  : null),
              porterWage:
                quoteData.generalInfo.porterWage ??
                (genenralInfoData.porter_wage != null
                  ? Number(genenralInfoData.porter_wage)
                  : null),
              packerWage:
                quoteData.generalInfo.packerWage ??
                (genenralInfoData.packer_wage != null
                  ? Number(genenralInfoData.packer_wage)
                  : null),
            };
          }
        }

        // Fill fuel rates from vehicle settings if not saved on the quote
        if (quoteData.generalInfo && fuelDetails) {
          if (!quoteData.generalInfo.petrolRate) {
            quoteData.generalInfo.petrolRate = fuelDetails?.petrol_rate
              ? Number(fuelDetails.petrol_rate)
              : null;
          }
          if (!quoteData.generalInfo.dieselRate) {
            quoteData.generalInfo.dieselRate = fuelDetails?.diesel_rate
              ? Number(fuelDetails.diesel_rate)
              : null;
          }
          if (!quoteData.generalInfo.electricRate) {
            quoteData.generalInfo.electricRate = fuelDetails?.electric_rate
              ? Number(fuelDetails.electric_rate)
              : null;
          }
        }

        return {
          id: index,
          label: `${index + 1}-${
            quote.created_at
              ? new Date(quote.created_at).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "2-digit",
                })
              : currentDate
          }`,
          data: quoteData,
          error: null,
        };
      });

      setQuoteTabs(newTabs);

      // Determine which tab to show - use last saved tab if available and valid, otherwise show last tab
      const tabToShow =
        lastSavedTabRef.current > 0 && lastSavedTabRef.current < newTabs.length
          ? lastSavedTabRef.current
          : newTabs.length - 1;

      const selectedQuoteData = JSON.parse(
        JSON.stringify(newTabs[tabToShow].data),
      );
      setEstimateForm(selectedQuoteData);
      setActiveTab(tabToShow);
    } else if (show && !selectedLeadQuote) {
      // Only set to initial if there's no data to load - set with default insurance type ID
      const initialData = JSON.parse(JSON.stringify(leadQuoteInitial));
      initialData.vatIncluded = newFinancialState?.is_vat_included ?? false;
      // Set default insurance type ID if available
      if (sales?.insurance_extended_liability_types?.length > 0) {
        const defaultInsuranceType =
          sales.insurance_extended_liability_types.find(
            (type: any) => type.name === "Goods value",
          );
        if (defaultInsuranceType) {
          initialData.insurance_type_id = defaultInsuranceType.id;
        }
      }
      // Always set provisionalDate for all initial services
      if (Array.isArray(initialData.services)) {
        initialData.services = initialData.services.map(
          (service: any, idx: number, arr: any[]) => ({
            ...service,
            provisionalDate: calculateProvisionalDate(
              service,
              arr,
              leadDetails,
            ),
          }),
        );
      }
      setEstimateForm(initialData);
    }
  }, [
    selectedLeadQuote,
    show,
    sales?.insurance_extended_liability_types,
    sales?.quote_expiry_days,
    genenralInfoData,
    leadDetails,
    fuelDetails,
    getDefaultServicesForQuote,
  ]);

  useEffect(() => {
    const insurancePercentage = estimateForm?.insurancePercentage;
    const price = estimateForm?.services?.[0]?.price;
    const userInsurance = Number(
      newFinancialState?.extended_liability_percent || 0,
    );
    // If insurancePercentage is not yet set and screen is quotation, then fill it
    if (
      screenType === "quotation" &&
      estimateForm?.services?.length > 0 &&
      (insurancePercentage === null || insurancePercentage === undefined) &&
      userInsurance > 0
    ) {
      const insuranceAmount = price
        ? (userInsurance / 100) * Number(price)
        : null;
      setEstimateForm((prev: any) => ({
        ...prev,
        insurancePercentage: userInsurance,
        insuranceAmount,
      }));
    }
  }, [
    estimateForm?.insurancePercentage,
    estimateForm?.services?.[0]?.price,
    newFinancialState?.extended_liability_percent,
    screenType,
  ]);

  // Sync paymentMethod and payment_method_id when data loads
  useEffect(() => {
    if (estimateForm && newFinancialState?.payment_methods?.length > 0) {
      let needsUpdate = false;
      let updates: any = {};

      // If we have a name but no ID, find and set the ID
      if (estimateForm.paymentMethod && !estimateForm.payment_method_id) {
        const method = newFinancialState.payment_methods.find(
          (m: any) => m.name === estimateForm.paymentMethod,
        );
        if (method) {
          updates.payment_method_id = method.id;
          needsUpdate = true;
        }
      }
      // If we have an ID but no name (or name doesn't match), find and set the name
      else if (estimateForm.payment_method_id && !estimateForm.paymentMethod) {
        const method = newFinancialState.payment_methods.find(
          (m: any) => m.id === estimateForm.payment_method_id,
        );
        if (method) {
          updates.paymentMethod = method.name;
          needsUpdate = true;
        }
      }

      if (needsUpdate) {
        setEstimateForm((prev: any) => ({ ...prev, ...updates }));
      }
    }
  }, [
    estimateForm?.paymentMethod,
    estimateForm?.payment_method_id,
    newFinancialState?.payment_methods,
  ]);

  // Sync insuranceType and insurance_type_id when data loads
  useEffect(() => {
    if (estimateForm && sales?.insurance_extended_liability_types?.length > 0) {
      let needsUpdate = false;
      let updates: any = {};

      // If we have a name but no ID, find and set the ID
      if (estimateForm.insuranceType && !estimateForm.insurance_type_id) {
        const type = sales.insurance_extended_liability_types.find(
          (t: any) => t.name === estimateForm.insuranceType,
        );
        if (type) {
          updates.insurance_type_id = type.id;
          needsUpdate = true;
        }
      }
      // If we have an ID but no name (or name doesn't match), find and set the name
      else if (estimateForm.insurance_type_id && !estimateForm.insuranceType) {
        const type = sales.insurance_extended_liability_types.find(
          (t: any) => t.id === estimateForm.insurance_type_id,
        );
        if (type) {
          updates.insuranceType = type.name;
          needsUpdate = true;
        }
      }

      if (needsUpdate) {
        setEstimateForm((prev: any) => ({ ...prev, ...updates }));
      }
    }
  }, [
    estimateForm?.insuranceType,
    estimateForm?.insurance_type_id,
    sales?.insurance_extended_liability_types,
  ]);

  // Auto-calculate insurance values on load when insurance type is already selected.
  useEffect(() => {
    if (!estimateForm || !sales?.insurance_extended_liability_types?.length) {
      return;
    }

    const normalizeTypeKey = (value: any) =>
      String(value || "")
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/[,_-]+/g, "")
        .replace(/_primary\d*$/, "");

    const hasValue = (value: any) =>
      value !== null && value !== undefined && value !== "";

    const selectedInsuranceType = sales.insurance_extended_liability_types.find(
      (type: any) =>
        type.id === estimateForm?.insurance_type_id ||
        type.name === estimateForm?.insuranceType,
    );

    if (!selectedInsuranceType) {
      return;
    }

    const removalService = (estimateForm?.services || []).find(
      (service: any) => {
        const typeKey = normalizeTypeKey(
          service?.type || service?.service_name || service?.typeName || "",
        );
        const nameKey = normalizeDropdownServiceName(service);

        return (
          typeKey === "removal" ||
          typeKey === "removaldoortodoor" ||
          nameKey === "removal" ||
          nameKey === "removal door to door" ||
          nameKey === "removal, door to door"
        );
      },
    );

    const removalPrice = Number(
      (removalService || estimateForm?.services?.[0])?.price || 0,
    );
    const hasInsuranceValues =
      hasValue(estimateForm?.insuranceAmount) &&
      hasValue(estimateForm?.insurancePercentage);
    const previousRemovalPrice = lastInsuranceCalcRemovalPriceRef.current;
    const isRemovalPriceChanged =
      previousRemovalPrice !== null &&
      Math.abs(previousRemovalPrice - removalPrice) > 0.009;

    if (hasInsuranceValues && !isRemovalPriceChanged) {
      lastInsuranceCalcRemovalPriceRef.current = removalPrice;
      return;
    }

    let insurancePercentage: number | string = "";
    let insuranceAmount: number | string = "";

    if (selectedInsuranceType.type === "percent") {
      insurancePercentage = Number(selectedInsuranceType.percent || 0);
      insuranceAmount = Number(
        ((removalPrice * Number(insurancePercentage || 0)) / 100).toFixed(2),
      );
    }

    if (selectedInsuranceType.type === "value") {
      insuranceAmount = Number(selectedInsuranceType.value || 0);
      insurancePercentage = removalPrice
        ? Number(
            ((Number(insuranceAmount || 0) / removalPrice) * 100).toFixed(2),
          )
        : 0;
    }

    const currentInsuranceAmount = Number(estimateForm?.insuranceAmount || 0);
    const currentInsurancePercentage = Number(
      estimateForm?.insurancePercentage || 0,
    );
    const nextInsuranceAmount = Number(insuranceAmount || 0);
    const nextInsurancePercentage = Number(insurancePercentage || 0);
    const hasInsuranceChanged =
      Math.abs(currentInsuranceAmount - nextInsuranceAmount) > 0.009 ||
      Math.abs(currentInsurancePercentage - nextInsurancePercentage) > 0.009 ||
      estimateForm?.insurance_type_id !== selectedInsuranceType.id ||
      estimateForm?.insuranceType !== selectedInsuranceType.name;

    if (!hasInsuranceChanged) {
      lastInsuranceCalcRemovalPriceRef.current = removalPrice;
      return;
    }

    const updatedData = {
      ...estimateForm,
      insuranceType: selectedInsuranceType.name,
      insurance_type_id: selectedInsuranceType.id,
      insurancePercentage,
      insuranceAmount,
    };

    const { estimateData: recalculatedData } = estimateChangeAction(
      {
        target: {
          id: "insuranceAmount",
          value: insuranceAmount,
        },
      },
      undefined,
      undefined,
      "number",
      updatedData,
      vehicles,
      subContractors,
    );

    setEstimateForm(recalculatedData);
    setQuoteTabs((prev) =>
      prev.map((tab, idx) =>
        idx === activeTab
          ? { ...tab, data: JSON.parse(JSON.stringify(recalculatedData)) }
          : tab,
      ),
    );
    lastInsuranceCalcRemovalPriceRef.current = removalPrice;
  }, [
    activeTab,
    estimateForm,
    sales?.insurance_extended_liability_types,
    subContractors,
    vehicles,
  ]);

  useEffect(() => {
    // if(settingWorkerModulePermission?.read){
    // dispatch(getAllVehicles());
    dispatch(getVehicleTypes());
    dispatch(getFuelDetails());
    dispatch(getGeneralInformationAction());
    dispatch(getAllMaterialAction());
    dispatch(getAllSaleAction());
    dispatch(getDefaultServiceListAction());
    // }
    setTimeout(() => {
      setLoad(true);
    }, 0);
    return () => {
      setLoad(false);
      dispatch(setLeadEstimateAction(null));
    };
  }, []);

  useEffect(() => {
    if (genenralInfoData?.id && estimateForm) {
      // Only fill default values if generalInfo is empty or has null values (new quote)
      const hasNoSavedValues =
        (estimateForm?.generalInfo?.driverWage === null ||
          estimateForm?.generalInfo?.driverWage === undefined) &&
        (estimateForm?.generalInfo?.porterWage === null ||
          estimateForm?.generalInfo?.porterWage === undefined) &&
        (estimateForm?.generalInfo?.packerWage === null ||
          estimateForm?.generalInfo?.packerWage === undefined);

      if (hasNoSavedValues) {
        setEstimateForm((prevState: any) => ({
          ...prevState,
          generalInfo: {
            ...prevState.generalInfo, // Preserve existing values
            driverWage:
              genenralInfoData?.driver_wage !== null &&
              genenralInfoData?.driver_wage !== undefined
                ? Number(genenralInfoData.driver_wage)
                : null,
            porterWage:
              genenralInfoData?.porter_wage !== null &&
              genenralInfoData?.porter_wage !== undefined
                ? Number(genenralInfoData.porter_wage)
                : null,
            packerWage:
              genenralInfoData?.packer_wage !== null &&
              genenralInfoData?.packer_wage !== undefined
                ? Number(genenralInfoData.packer_wage)
                : null,
            // contentsValue: genenralInfoData?.contents_value
            //   ? Number(genenralInfoData.contents_value)
            //   : null,
          },
        }));
      }
    }
  }, [genenralInfoData, estimateForm?.generalInfo?.driverWage]);

  // Pre-populate fuel rates from vehicle settings when not already saved on the quote
  useEffect(() => {
    if (fuelDetails && estimateForm) {
      const hasNoFuelRates =
        !estimateForm?.generalInfo?.petrolRate &&
        !estimateForm?.generalInfo?.dieselRate &&
        !estimateForm?.generalInfo?.electricRate;

      if (hasNoFuelRates) {
        setEstimateForm((prevState: any) => ({
          ...prevState,
          generalInfo: {
            ...prevState.generalInfo,
            petrolRate: fuelDetails?.petrol_rate
              ? Number(fuelDetails.petrol_rate)
              : null,
            dieselRate: fuelDetails?.diesel_rate
              ? Number(fuelDetails.diesel_rate)
              : null,
            electricRate: fuelDetails?.electric_rate
              ? Number(fuelDetails.electric_rate)
              : null,
          },
        }));
      }
    }
  }, [fuelDetails, estimateForm?.generalInfo?.petrolRate]);

  useEffect(() => {
    if (leadDetails?.lead?.status !== "NEW") {
      dispatch(
        getLeadEstimateAction({
          generatedId: leadDetails?.lead?.generated_id,
          screenType,
        }),
      );
    }
  }, [leadDetails?.lead?.generated_id]);

  useEffect(() => {
    if (vehicleTypes && vehicleTypes.length) {
      const vehiclesLocal: any = [];
      vehicleTypes &&
        vehicleTypes.map((ele: any) => {
          vehiclesLocal.push({ id: ele?.id, name: ele?.vehicle_type });
        });
      setVehiclesOptions(vehiclesLocal);
    } else {
      setVehiclesOptions([]);
    }
  }, [vehicleTypes]);

  useEffect(() => {
    if (!estimateForm || !Array.isArray(estimateForm?.services)) {
      return;
    }

    const totalDistanceMiles = getTotalDistanceMiles();
    let hasFuelUpdates = false;

    const servicesWithFuel = estimateForm.services.map((service: any) => {
      if (!Array.isArray(service?.vehicles) || service.vehicles.length === 0) {
        return service;
      }

      let serviceChanged = false;
      const updatedVehicles = service.vehicles.map((vehicle: any) => {
        if (vehicle?.isFuelChargeManual) {
          return vehicle;
        }

        const selectedVehicleType = (vehicleTypes || []).find(
          (type: any) =>
            type?.id === vehicle?.vehicleTypeId ||
            type?.type_id === vehicle?.vehicleTypeId,
        );

        const mpg = Number(selectedVehicleType?.efficiency || 0);
        const fuelRatePerLiter = getFuelRatePerLiter(
          selectedVehicleType?.fuel_type,
        );
        const vehicleQty = Number(vehicle?.vehicleQty ?? 0);

        let calculatedFuelCharge = 0;
        if (
          vehicle?.vehicleTypeId &&
          totalDistanceMiles > 0 &&
          mpg > 0 &&
          fuelRatePerLiter > 0
        ) {
          // Fuel (gallons) = distance / efficiency, liters = gallons * 4.546, price = liters * fuel-rate.
          const totalGallons = totalDistanceMiles / mpg;
          const totalLiters = totalGallons * 4.546;
          calculatedFuelCharge = Number(
            (totalLiters * fuelRatePerLiter * Math.max(vehicleQty, 0)).toFixed(
              2,
            ),
          );
        }

        const currentFuelCharge = Number(vehicle?.fuelCharge || 0);
        const hasFuelChanged =
          Math.abs(currentFuelCharge - calculatedFuelCharge) > 0.009;

        if (hasFuelChanged) {
          serviceChanged = true;
          hasFuelUpdates = true;
          return {
            ...vehicle,
            isFuelChargeManual: false,
            fuelCharge: calculatedFuelCharge ?? 0,
          };
        }

        return vehicle;
      });

      return serviceChanged
        ? {
            ...service,
            vehicles: updatedVehicles,
          }
        : service;
    });

    if (hasFuelUpdates) {
      const baseUpdatedEstimateForm = {
        ...estimateForm,
        services: servicesWithFuel,
      };
      const chargeableAncillariesTotal = (
        baseUpdatedEstimateForm?.ancillaries || []
      )
        .filter((a: any) => a?.isChargeable)
        .reduce((sum: number, a: any) => sum + Number(a?.charge || 0), 0);

      const recalculatedQuoteTotal =
        baseUpdatedEstimateForm?.materialPriceChargeable
          ? Number(
              (
                getTotal("total", baseUpdatedEstimateForm) +
                getTotal("serivesCost", baseUpdatedEstimateForm) +
                Number(baseUpdatedEstimateForm?.insuranceAmount || 0) +
                chargeableAncillariesTotal
              ).toFixed(2),
            )
          : Number(
              (
                getTotal("serivesCost", baseUpdatedEstimateForm) +
                Number(baseUpdatedEstimateForm?.insuranceAmount || 0) +
                chargeableAncillariesTotal
              ).toFixed(2),
            );

      const recalculatedCostTotal = Number(
        (
          getTotal("costsCost", baseUpdatedEstimateForm) +
          getTotal("wages", baseUpdatedEstimateForm) +
          getTotal("cost", baseUpdatedEstimateForm) +
          getTotal("ancillaries", baseUpdatedEstimateForm) +
          getTotal("subcontractorCharges", baseUpdatedEstimateForm)
        ).toFixed(2),
      );

      const updatedEstimateForm = {
        ...baseUpdatedEstimateForm,
        quoteTotal: recalculatedQuoteTotal,
        costTotal: recalculatedCostTotal,
      };
      setEstimateForm(updatedEstimateForm);
      setQuoteTabs((prev) =>
        prev.map((tab, idx) =>
          idx === activeTab
            ? { ...tab, data: JSON.parse(JSON.stringify(updatedEstimateForm)) }
            : tab,
        ),
      );
    }
  }, [
    activeTab,
    estimateForm,
    getFuelRatePerLiter,
    getTotalDistanceMiles,
    vehicleTypes,
  ]);

  useEffect(() => {
    if (subContractors && subContractors.length) {
      const subContractorLocal: any = [];
      subContractors &&
        subContractors.map((ele: any) => {
          subContractorLocal.push({ id: ele?.id, name: ele?.aka_name });
        });
      setSubContractorOptions(subContractorLocal);
    } else {
      setSubContractorOptions([]);
    }
  }, [subContractors]);

  // Handler for confirming duplication and applying the pending change
  const handleConfirmDuplicateAndApply = () => {
    setShowDuplicateAlert(false);
    handleDuplicateTab();
    // Wait for tab switch, then apply the pending change and force status to Initiated
    setTimeout(() => {
      const { event, section, index, valueFormat } =
        pendingChangeRef.current || {};
      if (event) {
        onChangeAction(event, section, index, valueFormat);
        // After applying the change, force status to Initiated
        setEstimateForm((prev: any) => ({
          ...prev,
          accepted_status: "Initiated",
          quoteId: null, // Clear quoteId for new quote
          status: prev.status ? "Initiated" : prev.status,
        }));
      }
      pendingChangeRef.current = null;
    }, 100);
  };

  // Handler for cancelling duplicate modal
  const handleCancelDuplicate = () => {
    setShowDuplicateAlert(false);
    pendingChangeRef.current = null;
  };

  const onChangeAction = (
    event: any,
    section?: any,
    index?: any,
    valueFormat?: any,
  ) => {
    // If current tab is Quoted, intercept and show modal
    // if (
    //   estimateForm?.accepted_status?.toLowerCase() === "quoted" &&
    //   !showDuplicateAlert
    // ) {
    //   pendingChangeRef.current = { event, section, index, valueFormat };
    //   setShowDuplicateAlert(true);
    //   return;
    // }
    // Handle paymentMethod separately - don't let estimateChangeAction process it
    if (event.target.id === "paymentMethod" && event.target.value) {
      const selectedPaymentMethod = newFinancialState?.payment_methods?.find(
        (method: any) =>
          method.id === event.target.value ||
          method.name === event.target.value,
      );
      if (selectedPaymentMethod) {
        const updatedData = {
          ...estimateForm,
          paymentMethod: selectedPaymentMethod.name,
          payment_method_id: selectedPaymentMethod.id,
        };
        setEstimateForm(updatedData);
        setQuoteTabs((prev) =>
          prev.map((tab, idx) =>
            idx === activeTab
              ? { ...tab, data: JSON.parse(JSON.stringify(updatedData)) }
              : tab,
          ),
        );
        setIsFieldValueChanged(true);
        return; // Exit early
      }
    }

    // Handle insuranceType separately - don't let estimateChangeAction process it
    if (event.target.id === "insuranceType" && event.target.value) {
      const selectedInsuranceType =
        sales?.insurance_extended_liability_types?.find(
          (type: any) =>
            type.id === event.target.value || type.name === event.target.value,
        );
      if (selectedInsuranceType) {
        const removalService = (estimateForm?.services || []).find(
          (service: any) => {
            const typeKey = getBaseDropdownServiceType(
              service?.type || service?.service_name || service?.typeName || "",
            );
            const nameKey = normalizeDropdownServiceName(service);

            return (
              typeKey === "removal" ||
              typeKey === "removaldoortodoor" ||
              nameKey === "removal" ||
              nameKey === "removal door to door" ||
              nameKey === "removal, door to door"
            );
          },
        );

        const removalPrice = Number(
          (removalService || estimateForm?.services?.[0])?.price || 0,
        );

        let insurancePercentage: number | string = "";
        let insuranceAmount: number | string = "";

        if (selectedInsuranceType.type === "percent") {
          insurancePercentage = Number(selectedInsuranceType.percent || 0);
          insuranceAmount = Number(
            ((removalPrice * insurancePercentage) / 100).toFixed(2),
          );
        }

        if (selectedInsuranceType.type === "value") {
          insuranceAmount = Number(selectedInsuranceType.value || 0);

          insurancePercentage = removalPrice
            ? Number(((insuranceAmount / removalPrice) * 100).toFixed(2))
            : 0;
        }

        const updatedData = {
          ...estimateForm,
          insuranceType: selectedInsuranceType.name,
          insurance_type_id: selectedInsuranceType.id,
          insurancePercentage,
          insuranceAmount,
        };

        const { estimateData: recalculatedData } = estimateChangeAction(
          {
            target: {
              id: "insuranceAmount",
              value: insuranceAmount,
            },
          },
          undefined,
          undefined,
          "number",
          updatedData,
          vehicles,
          subContractors,
        );

        setEstimateForm(recalculatedData);
        setQuoteTabs((prev) =>
          prev.map((tab, idx) =>
            idx === activeTab
              ? { ...tab, data: JSON.parse(JSON.stringify(recalculatedData)) }
              : tab,
          ),
        );
        setIsFieldValueChanged(true);
        return; // Exit early
      }
    }
    // content value
    if (event.target.id === "contentValue") {
      const updatedData = {
        ...estimateForm,
        contentValue: event.target.value,
      };

      setEstimateForm(updatedData);

      setQuoteTabs((prev) =>
        prev.map((tab, idx) =>
          idx === activeTab
            ? { ...tab, data: JSON.parse(JSON.stringify(updatedData)) }
            : tab,
        ),
      );

      setIsFieldValueChanged(true);
      return; // stop calculation flow
    }

    // For all other fields, use the normal flow
    let { estimateData } = estimateChangeAction(
      event,
      section,
      index,
      valueFormat,
      estimateForm,
      vehicles,
      subContractors,
    );

    if (
      section === "services" &&
      event?.target?.id === "typeName" &&
      estimateData?.services?.[index]
    ) {
      const selectedServiceId = String(event?.target?.value || "");
      const selectedService =
        getServiceOptionBySavedValue(selectedServiceId) ||
        serviceNameOptions?.find(
          (service: any) =>
            normalizeDropdownServiceName(service) ===
            normalizeDropdownServiceName({ name: selectedServiceId }),
        );

      const nextServices = [...estimateData.services];
      const currentServiceRow = nextServices[index];
      const removalService = serviceNameOptions.find((service: any) => {
        const typeKey = getBaseDropdownServiceType(service?.type || "");
        const nameKey = normalizeDropdownServiceName(service);

        return typeKey === "removal" || nameKey === "removal";
      });

      // const resolvedService = index === 0 ? removalService || selectedService : selectedService;
      const resolvedService = selectedService;

      const selectedType =
        index === 0
          ? "removal"
          : selectedService?.type ||
            currentServiceRow?.type ||
            selectedServiceId ||
            normalizeDropdownServiceType({ typeName: selectedServiceId });

      const uniqueSelectedType =
        index <= 1
          ? selectedType
          : getUniqueServiceType(selectedType, index, nextServices);

      nextServices[index] = {
        ...currentServiceRow,
        typeName:
          resolvedService?.name || resolvedService?.id || selectedServiceId,
        type: uniqueSelectedType,
        description:
          resolvedService?.description || currentServiceRow?.description || "",
      };

      estimateData = {
        ...estimateData,
        services: nextServices,
      };
    }

    // If the changed field is 'day' in a service, update provisionalDate for that service
    if (
      event.target &&
      event.target.id === "day" &&
      Array.isArray(estimateData.services)
    ) {
      const changedIdx = typeof index === "number" ? index : null;
      estimateData = {
        ...estimateData,
        services: estimateData.services.map(
          (service: any, idx: number, arr: any[]) =>
            idx === changedIdx
              ? {
                  ...service,
                  provisionalDate: calculateProvisionalDate(
                    service,
                    arr,
                    leadDetails,
                  ),
                }
              : service,
        ),
      };
    }

    setEstimateForm(estimateData);
    // Update current tab's data with deep copy
    setQuoteTabs((prev) =>
      prev.map((tab, idx) =>
        idx === activeTab
          ? { ...tab, data: JSON.parse(JSON.stringify(estimateData)) }
          : tab,
      ),
    );
    setIsFieldValueChanged(true); // Set field value changed flag
  };

  const onBlurAction = (event: any) => {
    const { isError, localError } = estimateValidateForm(
      estimateForm,
      isCostSection,
      screenType,
    );
    setError(localError);
  };

  const submitHandler = () => {
    const { isError, localError } = estimateValidateForm(
      estimateForm,
      isCostSection,
      screenType,
    );

    setError(localError);
    const hasServiceError =
      !!localError?.services && Object.keys(localError.services).length > 0;
    setChargesError(hasServiceError);
    setCostChargeError(hasServiceError);

    // ---------------------------
    // HELPERS
    // ---------------------------
    const getNumberOrZero = (val: any) =>
      val === null || val === undefined || val === "" ? 0 : Number(val);

    const isValidVehicle = (v: any) =>
      v?.vehicleTypeId ||
      (v?.vehicleQty !== null && v?.vehicleQty !== "") ||
      (v?.fuelCharge !== null && v?.fuelCharge !== "");

    if (!isError) {
      // Remember active tab
      lastSavedTabRef.current = activeTab;

      // Save current tab
      setQuoteTabs((prev) =>
        prev.map((tab, idx) =>
          idx === activeTab
            ? {
                ...tab,
                data: JSON.parse(JSON.stringify(estimateForm)),
                error: localError,
              }
            : tab,
        ),
      );

      // ---------------------------
      // SERVICE TRANSFORMATION
      // ---------------------------
      const transformServices = (services: any[]) =>
        services
          // STEP 1: Keep service if accepted OR price is provided
          .filter((service) => {
            const price = service?.price;
            const isAccepted =
              service?.isAccepted === true || service?.is_accepted === true;
            const isRemoval = service?.type?.toLowerCase() === "removal";

            // Allow Removal service always
            if (isRemoval) return true;

            // For other services, remove if price is 0 or empty
            // return isAccepted || price > 0;
            return (
              (isAccepted &&
                price !== null &&
                price !== undefined &&
                price !== "") ||
              (price !== null && price !== undefined && price !== "")
            );
          })

          // STEP 2: Transform each service
          .map((service, serviceIdx) => {
            let vehicles: any[] = [];

            if (Array.isArray(service?.vehicles)) {
              vehicles = service.vehicles
                .map((v: any, vIdx: number) => ({
                  vehicleTypeId: v?.vehicleTypeId ?? "",
                  vehicleQty: v?.vehicleQty ?? 0,
                  fuelCharge: v?.fuelCharge ?? 0,
                  orderIndex: v?.orderIndex ?? vIdx,
                }))
                // ✅ ONLY vehicleTypeId check — null/blank/undefined → vehicles: []
                .filter(
                  (v: any) =>
                    v.vehicleTypeId !== null &&
                    v.vehicleTypeId !== undefined &&
                    v.vehicleTypeId !== "",
                );
            } else {
              // ✅ fallback: only add if vehicleTypeId is valid
              if (
                service?.vehicleTypeId !== null &&
                service?.vehicleTypeId !== undefined &&
                service?.vehicleTypeId !== ""
              ) {
                vehicles = [
                  {
                    vehicleTypeId: service.vehicleTypeId,
                    vehicleQty: service?.vehicleQty ?? 0,
                    fuelCharge: service?.fuelCharge ?? 0,
                    orderIndex: 0,
                  },
                ];
              }
              // else → vehicles = [] already
            }

            const { vehicleQty, vehicleTypeId, fuelCharge, ...rest } = service;

            const isRemoval =
              service?.type?.toLowerCase() === "removal" || serviceIdx === 0;
            const dayValue =
              isRemoval && (service?.day === null || service?.day === undefined)
                ? 1
                : (service?.day ?? null);

            return {
              ...rest,
              driverQty: getNumberOrZero(service?.driverQty),
              porterQty: getNumberOrZero(service?.porterQty),
              packerQty: getNumberOrZero(service?.packerQty),
              wageCharge: getNumberOrZero(service?.wageCharge),
              vehicles: vehicles, // [] when vehicleTypeId null/blank/undefined
              day: dayValue,
              provisionalDate: service?.provisionalDate ?? null,
            };
          });

      // ---------------------------
      // FINAL PAYLOAD
      // ---------------------------
      const payload = {
        ...estimateForm,
        insuranceAmount: estimateForm?.insuranceAmount
          ? Number(estimateForm.insuranceAmount)
          : null,
        insurancePercentage: estimateForm?.insurancePercentage
          ? Number(estimateForm.insurancePercentage)
          : null,
        services: transformServices(estimateForm.services || []),
      };

      dispatch(
        addLeadQuoteAction({
          body: payload,
          generatedId: leadDetails?.lead?.generated_id,
          screenType: screenType,
        }),
      );

      setIsFieldValueChanged(false);
    }

    setIsShowActionCalled(false);
  };

  const handleAddExtraService = () => {
    setEstimateForm((prevState: any) => {
      const currentMaxOrderIndex = Math.max(
        0,
        ...(prevState?.services || [])
          .map((service: any) => Number(service?.orderIndex))
          .filter((order: number) => Number.isFinite(order)),
      );

      return {
        ...prevState,
        services: [
          ...prevState.services,
          {
            typeName: "",
            description: "",
            price: null,
            type: `extra_service_${currentMaxOrderIndex + 1}`,
            driverQty: null,
            porterQty: null,
            packerQty: null,
            vehicles: [
              {
                orderIndex: 1,
                vehicleQty: null,
                vehicleTypeId: "",
                fuelCharge: null,
              },
            ],
            wageCharge: null,
            orderIndex: currentMaxOrderIndex + 1,
          },
        ],
      };
    });
  };

  const handleAddExtraSubContractor = () => {
    setEstimateForm((prevState: any) => ({
      ...prevState,
      subcontractorCharges: [
        ...prevState.subcontractorCharges,
        {
          subContractorId: "",
          name: "",
          chargeAmount: null,
        },
      ],
    }));
  };

  // Function to delete a service by index
  const handleDeleteServiceRow = (index: number) => {
    setEstimateForm((prevState: any) => {
      const updatedServices = prevState.services.filter(
        (service: any, i: number) => i !== index,
      );

      // Call `estimateChangeAction` directly after deleting a service
      const { estimateData } = estimateChangeAction(
        { target: { name: "services", value: updatedServices } }, // Simulated event
        "services",
        index,
        undefined, // Pass valueFormat if needed
        { ...prevState, services: updatedServices },
        vehicles,
        subContractors,
      );

      return estimateData; // Update state with modified estimate data
    });
  };

  const handleDeleteSubContractorRow = (index: number) => {
    setEstimateForm((prevState: any) => {
      const updatedSubcontractors = prevState.subcontractorCharges.filter(
        (_: any, i: number) => i !== index,
      );

      const updatedEstimate = {
        ...prevState,
        subcontractorCharges: updatedSubcontractors,
      };

      const recalculatedCostTotal = Number(
        (
          getTotal("costsCost", updatedEstimate) +
          getTotal("wages", updatedEstimate) +
          getTotal("cost", updatedEstimate) +
          getTotal("ancillaries", updatedEstimate) +
          getTotal("subcontractorCharges", updatedEstimate)
        ).toFixed(2),
      );

      return {
        ...updatedEstimate,
        costTotal: recalculatedCostTotal,
      };
    });

    setIsFieldValueChanged(true);
  };

  const filteredLeadChargesHeading = isCostSection
    ? leadProfessionalChargesHeading // Show all headings if isCostSection is true
    : leadChargesHeading.filter(
        (heading) =>
          ![
            "Drivers",
            "Porters",
            "Packers",
            "Wages",
            "Vehicles",
            "Fuel",
          ].includes(heading.label),
      ); // Remove cost-related headings if isCostSection is false

  const filteredLeadChargesFields = isCostSection
    ? leadProfessionalChargesFields // Show all fields if isCostSection is true
    : leadChargesFields.filter(
        (field) =>
          ![
            "driverQty",
            "porterQty",
            "packerQty",
            "wageCharge",
            "vehicleTypeId",
            "vehicleQty",
            "fuelCharge",
          ].includes(field.id),
      ); // Remove cost-related fields if isCostSection is false

  const mergedServiceOptions = getMergedServiceOptions(estimateForm?.services);

  const serviceDropdownLeadChargesFields = filteredLeadChargesFields.map(
    (field: any) => {
      if (field?.id !== "typeName") return field;
      return {
        ...field,
        type: "select",
        placeHolder: "Select service",
        options: mergedServiceOptions,
      };
    },
  );

  const [isShowActionCalled, setIsShowActionCalled] = useState(false);

  const submitHandlerCallback = useCallback(() => {
    submitHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimateForm, isCostSection, screenType, activeTab]);

  useEffect(() => {
    if (isShowActionCalled) {
      submitHandlerCallback();
      // setIsShowActionCalled(false);
    }
  }, [isShowActionCalled, submitHandlerCallback]);

  // Tab handlers
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    // Save current tab data before switching (deep copy to preserve data)
    const updatedTabs = quoteTabs.map((tab, idx) =>
      idx === activeTab
        ? {
            ...tab,
            data: JSON.parse(JSON.stringify(estimateForm)),
            error: error,
          }
        : tab,
    );
    setQuoteTabs(updatedTabs);

    // Load selected tab's data
    const selectedTab = updatedTabs[newValue];
    setActiveTab(newValue);

    // Use tab's data if it exists, otherwise use initial
    if (selectedTab.data) {
      setEstimateForm(JSON.parse(JSON.stringify(selectedTab.data)));
    } else {
      setEstimateForm(JSON.parse(JSON.stringify(leadQuoteInitial)));
    }
    setError(selectedTab.error || null);
    setIsFieldValueChanged(false);
  };

  // current date DD Monthe YY format
  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
  });

  const handleAddNewTab = () => {
    // Check if there are unsaved changes
    if (isFieldValueChanged) {
      setShowNewQuoteConfirmDialog(true);
    } else {
      createNewTab();
    }
  };

  const handleCloseQuote = () => {
    // Check if there are unsaved changes
    if (isFieldValueChanged) {
      setShowCloseConfirmDialog(true);
    } else {
      closeQuoteScreen();
    }
  };

  const closeQuoteScreen = () => {
    setQuoteTabs([{ id: 0, label: "Quote 1", data: null, error: null }]);
    setActiveTab(0);
    setShow(false);
    setEstimateForm(null);
    setError(null);
    setIsFieldValueChanged(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const confirmAbandonChangesAndCreateNew = () => {
    setShowNewQuoteConfirmDialog(false);
    setIsFieldValueChanged(false);
    createNewTab();
  };

  const confirmAbandonChangesAndClose = () => {
    setShowCloseConfirmDialog(false);
    setIsFieldValueChanged(false);
    closeQuoteScreen();
  };

  const handleDuplicateTab = () => {
    const newTabId = quoteTabs.length;

    // Create duplicate data from current tab (copy all data EXCEPT quoteId)
    const duplicateData = JSON.parse(JSON.stringify(estimateForm));
    delete duplicateData.quoteId; // Remove quoteId so it becomes a new quote
    duplicateData.quoteId = null; // Explicitly set quoteId to null
    // Always force status to Initiated for duplicated tab
    duplicateData.accepted_status = "Initiated";
    duplicateData.isaccepted = false;
    // Defensive: If any other status field exists, reset it too
    if (duplicateData.status) {
      duplicateData.status = "Initiated";
    }
    // Save current tab and add duplicated tab
    const updatedTabs = [
      ...quoteTabs.map((tab, idx) =>
        idx === activeTab
          ? {
              ...tab,
              data: JSON.parse(JSON.stringify(estimateForm)),
              error: error,
            }
          : tab,
      ),
      {
        id: newTabId,
        label: `${newTabId + 1}-${currentDate}`,
        data: duplicateData,
        error: null,
      },
    ];

    // Update tabs
    setQuoteTabs(updatedTabs);

    // Switch to new duplicated tab
    setActiveTab(newTabId);
    setEstimateForm(JSON.parse(JSON.stringify(duplicateData)));
    setError(null);
    setIsFieldValueChanged(false);
  };

  const createNewTab = () => {
    const newTabId = quoteTabs.length;

    // Save current tab data FIRST before creating new tab
    const updatedTabs = quoteTabs.map((tab, idx) =>
      idx === activeTab
        ? {
            ...tab,
            data: JSON.parse(JSON.stringify(estimateForm)),
            error: error,
          }
        : tab,
    );
    setQuoteTabs(updatedTabs);
    // Get completely fresh initial structure (not using spread to avoid any reference issues)
    const initialData = JSON.parse(JSON.stringify(leadQuoteInitial));

    const getServicesForNewTab = () => {
      if (
        !Array.isArray(defaultServiceList) ||
        defaultServiceList.length === 0
      ) {
        return JSON.parse(JSON.stringify(initialData.services || []));
      }

      const normalizeKey = (value: any) =>
        String(value || "")
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/[,_-]+/g, "");

      const isRemovalService = (service: any) => {
        const typeKey = normalizeKey(service?.type);
        const nameKey = normalizeKey(
          service?.typeName || service?.service_name,
        );
        return (
          typeKey === "removal" ||
          typeKey === "removaldoortodoor" ||
          typeKey === "doortodoor" ||
          nameKey === "removal" ||
          nameKey === "removaldoortodoor" ||
          nameKey === "doortodoor"
        );
      };

      const isFullPackService = (service: any) => {
        const typeKey = normalizeKey(service?.type);
        const nameKey = normalizeKey(
          service?.typeName || service?.service_name,
        );
        return (
          typeKey === "fullpack" ||
          typeKey === "fullpacking" ||
          nameKey === "fullpack" ||
          nameKey === "fullpacking"
        );
      };

      const mappedServices = defaultServiceList
        .map((service: any, index: number) => {
          const serviceName =
            service?.name || service?.type_name || service?.service_name || "";

          return {
            typeName: serviceName,
            type: service?.type,
            service_name: service?.service_name,
            description: service?.description || "",
            price: null,
            isAccepted: !!service?.is_accepted,
            day: null,
            provisionalDate: null,
            driverQty: null,
            porterQty: null,
            packerQty: null,
            vehicles: [
              {
                orderIndex: 1,
                vehicleQty: null,
                vehicleTypeId: "",
                fuelCharge: null,
              },
            ],
            wageCharge: null,
            orderIndex:
              service?.order_index !== null &&
              service?.order_index !== undefined
                ? Number(service.order_index)
                : index + 1,
          };
        })
        .sort((a: any, b: any) => {
          const aOrder = Number.isFinite(Number(a?.orderIndex))
            ? Number(a.orderIndex)
            : Number.MAX_SAFE_INTEGER;
          const bOrder = Number.isFinite(Number(b?.orderIndex))
            ? Number(b.orderIndex)
            : Number.MAX_SAFE_INTEGER;
          return aOrder - bOrder;
        });

      const removalService = mappedServices.find((service: any) =>
        isRemovalService(service),
      );
      const fullPackService = mappedServices.find((service: any) =>
        isFullPackService(service),
      );
      const remainingServices = mappedServices.filter(
        (service: any) =>
          !isRemovalService(service) && !isFullPackService(service),
      );

      return [
        ...(removalService ? [removalService] : []),
        ...(fullPackService ? [fullPackService] : []),
        ...remainingServices,
      ].map((service: any, idx: number, arr: any[]) => ({
        ...service,
        orderIndex: idx + 1,
        day: idx === 0 && isRemovalService(service) ? 1 : null,
        provisionalDate: calculateProvisionalDate(service, arr, leadDetails),
      }));
    };

    // Get fresh materials from settings and merge with previous tab's filled values
    const getMaterialsForNewTab = () => {
      // Get structure from global settings
      let freshMaterials = [];
      if (materials && materials.length > 0) {
        freshMaterials = JSON.parse(JSON.stringify(materials));
      } else {
        freshMaterials = JSON.parse(JSON.stringify(leadQuoteInitial.materials));
      }

      // Get previous tab's material values
      const previousMaterials = estimateForm?.materials || [];

      // Merge: Take structure from settings, but copy ALL filled values from previous tab
      return freshMaterials.map((freshMaterial: any) => {
        // Find matching material in previous tab by name or materialId
        const matchingPrevious = previousMaterials.find(
          (prev: any) =>
            prev.name === freshMaterial.name ||
            (prev.materialId && prev.materialId === freshMaterial.materialId),
        );

        // If found in previous tab, copy ALL the filled values
        if (matchingPrevious) {
          return {
            ...freshMaterial,
            // Copy all possible material field values from previous tab
            surveyedQty: matchingPrevious.surveyedQty || 0,
            chargeQty: matchingPrevious.chargeQty || 0,
            quantity: matchingPrevious.quantity || 0,
            price: matchingPrevious.price || 0,
            total: matchingPrevious.total || 0,
            totalPrice: matchingPrevious.totalPrice || 0,
            volume: matchingPrevious.volume || 0,
            cost: matchingPrevious.cost || 0,
          };
        }
        // Otherwise return material from settings, but set user-input fields to 0 if not already set
        return {
          ...freshMaterial,
          price: freshMaterial.rate ?? 0,
          surveyedQty: freshMaterial.surveyedQty ?? 0,
          chargeQty: freshMaterial.chargeQty ?? 0,
          quantity: freshMaterial.quantity ?? 0,
          total: freshMaterial?.total ?? 0,
          totalPrice: freshMaterial?.totalPrice ?? 0,
          volume: freshMaterial.volume ?? 0,
          cost: freshMaterial.cost ?? 0,
        };
      });
    };

    // Build completely fresh data object from scratch
    const freshTabData = {
      quoteTotal: null,
      costTotal: null,
      quoteExpiresOn: dayjs()
        .add(Number(sales?.quote_expiry_days) || 90, "days")
        .toISOString(),
      notes: leadDetails?.lead?.customer_notes || "",
      transportnote: "",
      quotenote: "",
      vatIncluded: newFinancialState?.is_vat_included ?? false,
      materialPriceChargeable: false,
      services: getServicesForNewTab(),
      materials: getMaterialsForNewTab(), // 👈 Only field copied from settings/previous tab
      generalInfo: {
        driverWage:
          genenralInfoData?.driver_wage !== null &&
          genenralInfoData?.driver_wage !== undefined
            ? Number(genenralInfoData.driver_wage)
            : null,
        porterWage:
          genenralInfoData?.porter_wage !== null &&
          genenralInfoData?.porter_wage !== undefined
            ? Number(genenralInfoData.porter_wage)
            : null,
        packerWage:
          genenralInfoData?.packer_wage !== null &&
          genenralInfoData?.packer_wage !== undefined
            ? Number(genenralInfoData.packer_wage)
            : null,
      },
      paymentMethod: "",
      payment_method_id: null,
      contentValue: null,
      insuranceAmount: null,
      insurancePercentage: null,
      accepted_status: "Initiated",
      insuranceType: "Goods value",
      insurance_type_id: null,
      ancillaries: [
        { name: "Tolls", charge: null, isChargeable: false },
        { name: "Ferry charges", charge: null, isChargeable: false },
        { name: "", charge: null, isChargeable: false },
      ],
      subcontractorCharges: [
        {
          subContractorId: "",
          name: "",
          chargeAmount: null,
        },
      ],
    };

    // Set default insurance_type_id if available
    if (sales?.insurance_extended_liability_types?.length > 0) {
      const defaultInsuranceType =
        sales.insurance_extended_liability_types.find(
          (type: any) => type.name === "Goods value",
        );
      if (defaultInsuranceType) {
        freshTabData.insurance_type_id = defaultInsuranceType.id;
      }
    }

    const newTab = {
      id: newTabId,
      label: `${newTabId + 1}-${currentDate}`,
      data: JSON.parse(JSON.stringify(freshTabData)),
      error: null,
    };

    // Add new tab to the saved tabs
    setQuoteTabs([...updatedTabs, newTab]);

    // Clear form first to force unmount of all fields
    setEstimateForm(null);
    setError(null);

    // Then set new tab and fresh data to force remount with clean values
    setTimeout(() => {
      setActiveTab(newTabId);
      setEstimateForm(JSON.parse(JSON.stringify(freshTabData)));
      setIsFieldValueChanged(false);
    }, 0);
  };

  const handleRemoveTab = (tabIndex: number, event: React.MouseEvent) => {
    event.stopPropagation();

    if (quoteTabs.length === 1) return; // Don't remove last tab

    // Store the tab index to delete
    setTabToDelete(tabIndex);

    // Check if the quote is accepted
    const tabData = quoteTabs[tabIndex]?.data as any;
    if (
      tabData?.quoteId &&
      tabData?.accepted_status?.toLowerCase() === "accepted" &&
      !tabData?.isDeletable
    ) {
      // Show AlertMessage for accepted quotes
      setShowAcceptedQuoteAlert(true);
    } else {
      // Show confirmation dialog for other quotes
      setShowDeleteConfirmDialog(true);
    }
  };

  const confirmDeleteTab = () => {
    if (tabToDelete === null) return;

    // Save current tab data before removing
    const savedTabs = quoteTabs.map((tab, idx) =>
      idx === activeTab
        ? {
            ...tab,
            data: JSON.parse(JSON.stringify(estimateForm)),
            error: error,
          }
        : tab,
    );

    const tabData = savedTabs[tabToDelete]?.data;
    const quoteId = tabData?.quoteId;

    // If quoteId exists, call API to delete
    if (quoteId) {
      dispatch(
        deleteSingleLeadQuoteAction({
          quoteId: quoteId,
          leadId: leadDetails?.lead?.generated_id,
          screenType: screenType,
        }),
      );
    }

    // Remove the tab and its data
    const newTabs = savedTabs.filter((_tab, idx) => idx !== tabToDelete);
    setQuoteTabs(newTabs);

    // Adjust active tab
    if (activeTab === tabToDelete) {
      const newActiveTab = Math.max(0, tabToDelete - 1);
      setActiveTab(newActiveTab);
      const selectedTab = newTabs[newActiveTab];
      setEstimateForm(
        selectedTab.data
          ? JSON.parse(JSON.stringify(selectedTab.data))
          : JSON.parse(JSON.stringify(leadQuoteInitial)),
      );
      setError(selectedTab.error || null);
      setIsFieldValueChanged(false);
    } else if (activeTab > tabToDelete) {
      setActiveTab(activeTab - 1);
    }

    // Close dialog and reset
    setShowDeleteConfirmDialog(false);
    setTabToDelete(null);
  };

  // Add a vehicle to a specific service
  const onAddVehicle = (serviceIdx: number) => {
    setEstimateForm((prev: any) => {
      const updatedServices = prev.services.map((service: any, idx: number) => {
        if (idx === serviceIdx) {
          return {
            ...service,
            vehicles: [
              ...(Array.isArray(service.vehicles) ? service.vehicles : []),
              {
                vehicleQty: null,
                vehicleTypeId: "",
                fuelCharge: null,
              },
            ],
          };
        }
        return service;
      });
      return { ...prev, services: updatedServices };
    });
  };

  const handleExtraVehicleChange = (
    e: any,
    serviceIdx: number,
    vehicleIdx: number,
  ) => {
    onChangeAction(e, `services[${serviceIdx}].vehicles`, vehicleIdx);
  };

  const handleRemoveVehicle = (serviceIdx: number, vehicleIdx: number) => {
    setEstimateForm((prev: any) => {
      if (!prev || !prev.services) return prev;
      const updatedServices = prev.services.map(
        (service: any, sIdx: number) => {
          if (sIdx !== serviceIdx) return service;
          return {
            ...service,
            vehicles: service.vehicles.filter(
              (_: any, vIdx: number) => vIdx !== vehicleIdx,
            ),
          };
        },
      );
      return { ...prev, services: updatedServices };
    });
  };

  // Transform services: remove 'Removal' if 'Removal, Door to Door' exists, and 'Full Pack' if 'Full Packing' exists
  function getTransformedServices(services: any[]) {
    if (!Array.isArray(services)) return [];
    const hasDoorToDoor = services.some(
      (s) => s.typeName === "Removal, Door to Door",
    );
    const hasFullPacking = services.some(
      (s) => s?.typeName.toLowerCase() === "full packing",
    );
    let filtered = services.filter((service) => {
      if (hasFullPacking && service?.typeName?.toLowerCase() === "full pack")
        return false;
      if (hasDoorToDoor && service.typeName === "Removal") return false;
      return true;
    });
    return filtered.sort((a: any, b: any) => {
      const aOrder =
        a?.orderIndex === null || a?.orderIndex === undefined
          ? Number.MAX_SAFE_INTEGER
          : Number(a.orderIndex);
      const bOrder =
        b?.orderIndex === null || b?.orderIndex === undefined
          ? Number.MAX_SAFE_INTEGER
          : Number(b.orderIndex);
      return aOrder - bOrder;
    });
  }

  const transformedServices = getTransformedServices(estimateForm?.services);
  const defaultServiceTypeKeys = new Set(
    (defaultServiceList || []).flatMap((service: any) => {
      const keys = [
        service?.name,
        service?.type_name,
        service?.service_name,
        service?.type,
      ]
        .map((value) => getServiceTypeKey(value))
        .filter(Boolean);
      return keys;
    }),
  );

  return (
    <>
      {/* Duplicate Alert Modal */}
      {showDuplicateAlert && (
        <AlertPopup
          open={showDuplicateAlert}
          onHide={handleCancelDuplicate}
          submitHandler={handleConfirmDuplicateAndApply}
          title="Duplicate Quote"
          content="This quote has been sent to the customer previously. Do you want to duplicate the quote and apply your changes to the new quote?"
          yesText="Yes"
          noText="No"
        />
      )}
      <div
        id="estimate-popup-fixed"
        className={classes.estimatePopupContainer}
        style={{
          zIndex: show ? 11 : -1,
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ height: "auto", zIndex: 99, paddingLeft: "0px" }}
          >
            <div className={classes.popupTitle}>
              {/* <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}> */}
              <Box
                sx={{
                  display: "inline-block",
                  px: 3,
                  py: 1,
                  backgroundColor: getLeadColor(
                    screenType === "quotation" ? "QUOTE" : "ESTIMATES",
                  ),
                  color: "white",
                  clipPath:
                    "polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    marginLeft: "2px",
                    paddingLeft: "6px !important",
                    textAlign: "center",
                  }}
                  variant="subtitle1"
                >
                  {screenType ? "Quote" : "Estimate"}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  color: getLeadColor(
                    screenType === "quotation" ? "QUOTE" : "ESTIMATES",
                  ),
                  marginLeft: "10px",
                  textAlign: "center",
                }}
                variant="subtitle1"
              >
                {screenType ? "Quotation" : "Estimate"}
              </Typography>
              {/* </Box> */}
              <Box>
                {disabledField && estimateForm?.hasFinalInvoice ? (
                  // ||
                  // leadDetails?.lead?.status === "JOB" ||
                  // estimateForm?.accepted_status?.toLowerCase() === "accepted"
                  ""
                ) : (
                  <img
                    onClick={() => submitHandler()}
                    src={checkedIcon}
                    style={{
                      cursor: "pointer",
                      height: "26px",
                      width: "26px",
                      marginRight: 10,
                    }}
                    alt="save"
                  />
                )}
                <img
                  src={closeIcon}
                  style={{ cursor: "pointer", height: "26px", width: "26px" }}
                  onClick={handleCloseQuote}
                  alt="cross-icon"
                />
              </Box>
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              opacity: load ? 1 : 0,
              paddingLeft: "0px !important",
            }}
          >
            <Notification />
            {disabledField && (
              <div
                style={{
                  fontSize: "14px",
                  color: "#FF0000",
                  background: "rgb(239 209 209)",
                  marginBottom: "10px",
                  padding: "10px",
                }}
              >
                {screenType !== "quotation" ? "Estimate" : "Quote"} is read only
                due to moved on next step.
              </div>
            )}
            <Grid container spacing={2} sx={{ fontSize: "14px" }}>
              <Grid item xs={12} sm={12} sx={{ paddingLeft: "0px !important" }}>
                <LeadDetailSection leadDetails={leadDetails} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              opacity: load ? 1 : 0,
              paddingLeft: "0px !important",
              paddingTop: "0px !important",
              backgroundColor: "#E5F4F1",
              borderRadius: "5px",
            }}
          >
            {/* Tabs Section - Above Services */}
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fff",
                padding: "10px 16px",
                gap: 1,
                marginBottom: "10px",
                borderRadius: "5px 5px 0 0",
              }}
            >
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  flex: 1,
                  minHeight: "40px",
                  "& .MuiTab-root": {
                    minHeight: "40px",
                    padding: "8px 16px",
                  },
                }}
              >
                {quoteTabs.map((tab, index) => {
                  const tabStatus =
                    index === activeTab
                      ? estimateForm?.accepted_status
                      : (tab?.data as any)?.accepted_status;

                  const isQuoted = tabStatus?.toLowerCase() === "quoted";
                  const isAccepted = tabStatus?.toLowerCase() === "accepted";
                  const isDeletedAllow = estimateForm?.isDeletable;
                  const bgColor = isAccepted
                    ? "#E3F2FD"
                    : isQuoted
                      ? "#E8F5E9"
                      : "#F5F5F5";
                  const txtColor = isAccepted
                    ? "#1565C0"
                    : isQuoted
                      ? "#2E7D32"
                      : "#757575";
                  return (
                    <Tab
                      key={tab?.label || index}
                      label={
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <span>
                            {tab.label}
                            <br />
                            <Chip
                              label={tabStatus || "Initiated"} // ✅ each tab's own status
                              size="small"
                              sx={{
                                mt: 0.5,
                                fontSize: "10px",
                                height: "16px",
                                backgroundColor: "#E0E0E0",
                                color: txtColor,
                                textTransform: "uppercase",
                              }}
                            />
                          </span>
                          {quoteTabs.length > 0 && isDeletedAllow && (
                            <IconButton
                              size="small"
                              onClick={(e) => handleRemoveTab(index, e)}
                              sx={{
                                padding: "2px",
                                marginLeft: "4px",
                                "&:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.08)",
                                },
                              }}
                            >
                              <span style={{ fontSize: "18px", lineHeight: 1 }}>
                                &times;
                              </span>
                            </IconButton>
                          )}
                        </Box>
                      }
                      sx={{
                        textTransform: "none",
                        fontSize: "13px",
                        fontWeight: 500,
                        borderRadius: "6px",
                        mr: 1,
                        backgroundColor: bgColor, // ✅ each tab's own color
                        color: txtColor, // ✅ each tab's own color
                        opacity: isQuoted || isAccepted ? 1 : 0.8,
                      }}
                    />
                  );
                })}
              </Tabs>
              <Button
                onClick={handleAddNewTab}
                variant="outlined"
                size="small"
                disabled={
                  leadDetails?.lead?.status === "COMPLETED"
                  // leadDetails?.lead?.status === "JOB"
                }
                sx={{
                  minWidth: "auto",
                  padding: "6px 14px",
                  fontSize: "12px",
                  textTransform: "none",
                  fontWeight: 600,
                  borderColor: getLeadColor(
                    screenType === "quotation" ? "QUOTE" : "ESTIMATES",
                  ),
                  color: getLeadColor(
                    screenType === "quotation" ? "QUOTE" : "ESTIMATES",
                  ),
                  "&:hover": {
                    borderColor: getLeadColor(
                      screenType === "quotation" ? "QUOTE" : "ESTIMATES",
                    ),
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                  "&:disabled": {
                    borderColor: "#ccc",
                    color: "#999",
                  },
                }}
              >
                + Add New
              </Button>
            </Box>
            <Box sx={{ width: "100%", overflow: "hidden" }}>
              {/* {estimateForm?.accepted_status?.toLowerCase() === "quoted" && (
                <Alert severity="warning" sx={{ width: "100%" }}>
                  This quote has been sent to the customer previously so if you
                  are about to change any values, it is suggested that you
                  duplicate the Quote first.
                </Alert>
              )} */}
              {estimateForm?.accepted_status?.toLowerCase() === "accepted" && (
                <Alert severity="warning" sx={{ width: "100%" }}>
                  This quote is accepted. You can add new services, but existing
                  items are locked. To remove an item, duplicate the quote
                </Alert>
              )}
            </Box>
            <div className={classes.container} style={{ paddingBottom: 10 }}>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{ paddingLeft: "0px !important" }}
                >
                  <div
                    className={classes.container}
                    style={{
                      height: "calc(100% - 45px)",
                      paddingBottom: 0,
                      border: isCostSection
                        ? costChargeError || chargesError
                          ? "1px solid red"
                          : "1px solid #DDD"
                        : chargesError
                          ? "1px solid red"
                          : "1px solid #DDD",
                    }}
                  >
                    {/* <Typography variant="subtitle1">Services</Typography> */}
                    <RenderEstimateTable
                      {...{
                        estimateForm,
                        onChangeAction,
                        handleDeleteServiceRow,
                        vehiclesOptions,
                        onAddVehicle,
                        onBlurAction,
                        error,
                        tableHeadding: filteredLeadChargesHeading,
                        tableContent: transformedServices,
                        fields: serviceDropdownLeadChargesFields,
                        additionRow: (
                          <>
                            {transformedServices?.length >= 1 &&
                              transformedServices?.filter(
                                (service: any) =>
                                  !service.isAccepted &&
                                  !defaultServiceTypeKeys.has(
                                    getServiceTypeKey(
                                      service?.typeName ||
                                        service?.type ||
                                        service?.service_name,
                                    ),
                                  ),
                              ).length < 3 && (
                                <TableRow>
                                  <TableCell
                                    sx={{
                                      fontWeight: 600,
                                      paddingTop: "10px!important",
                                    }}
                                  ></TableCell>
                                  <TableCell colSpan={10}></TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: 600,
                                      paddingTop: "10px!important",
                                    }}
                                  >
                                    <CustomButton
                                      disabled={
                                        leadDetails?.lead?.status ===
                                          "COMPLETED" ||
                                        (estimateForm?.hasFinalInvoice ===
                                          true &&
                                          estimateForm?.accepted_status?.toLowerCase() ===
                                            "accepted")
                                      }
                                      style={{
                                        marginRight: "10px",
                                        fontSize: "10px",
                                        padding: "0px 6px",
                                        fontWeight: 600,
                                        backgroundColor: "#fff",
                                      }}
                                      variant="outlined"
                                      title="+ More"
                                      onClick={handleAddExtraService}
                                    />
                                  </TableCell>
                                </TableRow>
                              )}

                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  paddingTop: "20px!important",
                                }}
                              >
                                Total
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  paddingTop: "20px!important",
                                  paddingLeft: "10px !important",
                                  textAlign: "left",
                                }}
                              >
                                £
                                {getTotal(
                                  "serivesCost",
                                  estimateForm,
                                ).toLocaleString("en-GB")}
                              </TableCell>

                              <>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell
                                  sx={{
                                    fontWeight: 600,
                                    paddingTop: "20px!important",
                                  }}
                                >
                                  {getTotal("wages", estimateForm)}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell
                                  sx={{
                                    fontWeight: 600,
                                    paddingTop: "20px!important",
                                  }}
                                >
                                  £
                                  {getTotal(
                                    "costsCost",
                                    estimateForm,
                                  ).toLocaleString("en-GB")}
                                </TableCell>
                              </>
                            </TableRow>
                          </>
                        ),
                        section: "services",
                        disabled: disabledField,
                        renderExtraRows: (service: any, idx: number) => (
                          <>
                            {Array.isArray(service.vehicles) &&
                              service.vehicles.length > 1 &&
                              service.vehicles
                                .slice(1)
                                .map((vehicle: any, vIdx: number) => (
                                  <TableRow
                                    key={`vehicle-row-${idx}-${vIdx + 1}`}
                                  >
                                    <TableCell colSpan={9}></TableCell>
                                    {/* Vehicle Type */}
                                    <TableCell
                                      sx={{
                                        width: "100px !important",
                                      }}
                                    >
                                      <FormField
                                        type="select"
                                        id="vehicleTypeId"
                                        value={vehicle?.vehicleTypeId}
                                        onChange={(e) =>
                                          handleExtraVehicleChange(
                                            e,
                                            idx,
                                            vIdx + 1,
                                          )
                                        }
                                        options={vehiclesOptions}
                                        placeholder="Select"
                                        width={"100px"}
                                        disabled={disabledField}
                                        error={
                                          error?.services?.[idx]?.vehicles?.[
                                            vIdx + 1
                                          ]
                                        }
                                      />
                                    </TableCell>
                                    {/* Vehicle Qty */}
                                    <TableCell>
                                      <FormField
                                        type="number"
                                        id="vehicleQty"
                                        value={vehicle?.vehicleQty}
                                        onChange={(e) =>
                                          handleExtraVehicleChange(
                                            e,
                                            idx,
                                            vIdx + 1,
                                          )
                                        }
                                        placeholder="Qty"
                                        disabled={disabledField}
                                        error={
                                          error?.services?.[idx]?.vehicles?.[
                                            vIdx + 1
                                          ]
                                        }
                                      />
                                    </TableCell>
                                    {/* Fuel Charge */}
                                    <TableCell>
                                      <FormField
                                        type="number"
                                        id="fuelCharge"
                                        value={vehicle?.fuelCharge}
                                        onChange={(e) =>
                                          handleExtraVehicleChange(
                                            e,
                                            idx,
                                            vIdx + 1,
                                          )
                                        }
                                        placeholder="£ Charge"
                                        disabled={disabledField}
                                        error={
                                          error?.services?.[idx]?.vehicles?.[
                                            vIdx + 1
                                          ]
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 600,
                                        paddingTop: "10px!important",
                                      }}
                                    >
                                      <IconButton
                                        sx={{ padding: "0px" }}
                                        onClick={(e) =>
                                          handleRemoveVehicle(idx, vIdx + 1)
                                        }
                                        color="error"
                                      >
                                        <DeleteOutlined />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}
                          </>
                        ),
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          {/* Material */}
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              opacity: load ? 1 : 0,
              paddingLeft: "0px !important",
              paddingTop: "10px !important",
            }}
          >
            <div
              className={classes.container}
              style={{
                backgroundColor: estimateForm?.requirements?.some(
                  (req: any) =>
                    req.service_name === "material" && req.is_accepted,
                )
                  ? "#B5D6CD"
                  : "#E5F4F1",
                // background: "#E5F4F1",
              }}
            >
              {" "}
              <RenderEstimateTable
                {...{
                  estimateForm,
                  onChangeAction,
                  vehiclesOptions,
                  onBlurAction,
                  error,
                  screenType,
                  tableHeadding:
                    screenType !== "quotation"
                      ? leadEstimateMaterialsHeading
                      : leadMaterialsHeading,
                  tableContent: estimateForm?.materials,
                  fields:
                    screenType !== "quotation"
                      ? leadEstimateMaterialsFields
                      : leadMaterialsFields,
                  additionRow: (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                      <TableCell colSpan={2}>
                        <FormControlLabel
                          label="Material Price Chargeable"
                          labelPlacement="start"
                          control={
                            <Checkbox
                              sx={{
                                marginTop: "16px",
                                marginLeft: "6px !important",
                                width: "auto !important",
                              }}
                              checked={estimateForm?.materialPriceChargeable}
                              disabled={disabledField}
                              onChange={(e: any) => onChangeAction(e)}
                              name="materialPriceChargeable"
                              id="materialPriceChargeable"
                              color="primary"
                            />
                          }
                          sx={{
                            marginLeft: "0px !important",
                            "& .MuiFormControlLabel-label": {
                              fontSize: "13px", // Set your desired font size here
                              display: "flex",
                            },
                          }}
                        />
                      </TableCell>
                      {screenType === "quotation" && <TableCell></TableCell>}
                      <TableCell sx={{ fontWeight: 600 }}>
                        £
                        {getTotal("total", estimateForm).toLocaleString(
                          "en-GB",
                        )}
                      </TableCell>
                      {screenType === "quotation" && (
                        <>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {getTotal("volume", estimateForm)}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            £
                            {getTotal("cost", estimateForm).toLocaleString(
                              "en-IN",
                            )}
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ),
                  section: "materials",
                  disabled: disabledField,
                }}
              />
            </div>
          </Grid>

          {/* Charges */}
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              opacity: load ? 1 : 0,
              paddingLeft: "0px !important",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #ddd",
              marginTop: "10px",
              paddingBottom: "10px",
            }}
          >
            <Grid container spacing={2} sx={{ marginBottom: "16px" }}>
              <Grid
                item
                xs={12}
                sm={3.5}
                sx={{ paddingLeft: "0px !important" }}
              >
                <div className={classes.container}>
                  <RenderEstimateTable
                    {...{
                      estimateForm,
                      onChangeAction,
                      vehiclesOptions,
                      onBlurAction,
                      error,
                      tableHeadding: leadGenInfoHeading,
                      tableContent: leadGenInoList,
                      fields: leadGenInfoFields,
                      additionRow: null,
                      section: "generalInfo",
                      disabled: disabledField,
                    }}
                  />
                </div>
              </Grid>

              <Grid
                item
                xs={12}
                sm={3.5}
                sx={{ paddingLeft: "0px !important" }}
              >
                <div className={classes.container}>
                  <RenderEstimateTable
                    {...{
                      estimateForm,
                      onChangeAction,
                      vehiclesOptions,
                      onBlurAction,
                      error,
                      tableHeadding: leadAncillariesHeading,
                      tableContent: estimateForm?.ancillaries,
                      fields: leadAncillariesFields,
                      additionRow: (
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {getTotal("ancillaries", estimateForm)}
                          </TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      ),
                      section: "ancillaries",
                      disabled: disabledField,
                    }}
                  />
                </div>
              </Grid>
              {/* Subcontractor */}
              <Grid item xs={12} sm={5} sx={{ paddingLeft: "0px !important" }}>
                <div className={classes.container}>
                  {/* <QuoteSubContractor/>                    */}
                  <RenderEstimateTable
                    {...{
                      estimateForm,
                      onChangeAction,
                      handleDeleteSubContractorRow,
                      subContractorOptions,
                      onBlurAction,
                      error,
                      tableHeadding: leadQuoteSubcontractorHeading,
                      tableContent: estimateForm?.subcontractorCharges,
                      fields: leadQuoteSubcontractorFields,
                      additionRow: (
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 600,
                              paddingTop: "10px!important",
                            }}
                          >
                            <CustomButton
                              disabled={
                                disabledField ||
                                !estimateForm?.subcontractorCharges?.length ||
                                !estimateForm?.subcontractorCharges[
                                  estimateForm.subcontractorCharges.length - 1
                                ]?.name ||
                                !estimateForm?.subcontractorCharges[
                                  estimateForm.subcontractorCharges.length - 1
                                ]?.chargeAmount
                              }
                              style={{
                                marginRight: "10px",
                                fontSize: "10px",
                                padding: "0px 6px",
                                fontWeight: 600,
                                backgroundColor: "#fff",
                              }}
                              variant="outlined"
                              title="+ More"
                              onClick={handleAddExtraSubContractor}
                            />
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {getTotal("subcontractorCharges", estimateForm)}
                          </TableCell>
                        </TableRow>
                      ),
                      section: "subcontractorCharges",
                      disabled: disabledField,
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            {/* payment method */}
            {screenType === "quotation" && (
              <>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    marginLeft: "0px !important",
                    width: "100% !important",
                    paddingTop: "10px",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={1.5}
                    className={classes.labelBox}
                    alignItems="center"
                    sx={{
                      margin: "0!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "14px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "17px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                      htmlFor={"paymentMethod"}
                    >
                      Payment method
                    </InputLabel>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    style={{
                      padding: "0px 0px 0px 8px",
                      display: "flex",
                      justifyContent: "center",
                      paddingLeft: "16px !important",
                    }}
                  >
                    <FormField
                      // key={field.id}
                      onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                        e.preventDefault()
                      }
                      {...{
                        id: "paymentMethod",
                        type: "select",
                        variant: "outlined", // Adding this variant prop
                        isNonMarginTop: true,
                        value: (() => {
                          // Try to find by name first, then by id
                          if (estimateForm?.paymentMethod) {
                            const method =
                              newFinancialState?.payment_methods?.find(
                                (m: any) =>
                                  m.name === estimateForm.paymentMethod,
                              );
                            return method
                              ? method.id
                              : estimateForm.paymentMethod;
                          }
                          if (estimateForm?.payment_method_id) {
                            return estimateForm.payment_method_id;
                          }
                          return "";
                        })(),
                        options: newFinancialState?.payment_methods ?? [],
                        disabled: disabledField,
                        InputProps: {
                          sx: {
                            padding: "2px 4px",
                            height: "36px",
                          },
                        },

                        onChange: (e: any) =>
                          onChangeAction(e, "generalInfo", 0),
                        onBlur: onBlurAction,
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Insursnce UI */}
                <Grid
                  container
                  spacing={1}
                  sx={{
                    marginLeft: "0px !important",
                    width: "100% !important",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={1.5}
                    // className={classes.labelBox}
                    alignItems="center"
                    sx={{
                      margin: "0!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "14px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: estimateForm?.requirements?.some(
                          (req: any) =>
                            req.service_name === "insurance" && req.is_accepted,
                        )
                          ? "#008E72"
                          : "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                      htmlFor={"paymentMethod"}
                    >
                      Insurance :
                    </InputLabel>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{
                      display: "flex",
                      paddingLeft: "0px !important",
                      alignItems: "center",
                      paddingTop: "0px !important",
                    }}
                  >
                    <Grid
                      container
                      spacing={1}
                      sx={{
                        display: "flex",
                        marginTop: "0px",
                        alignItems: "center",
                      }}
                    >
                      <>
                        {leadEstimateInsuranceGeneralFields.map(
                          (field: any, idx: number) => {
                            return (
                              <FormField
                                key={idx}
                                onPaste={(
                                  e: React.ClipboardEvent<HTMLInputElement>,
                                ) => e.preventDefault()}
                                onKeyDown={(event: any) => {
                                  if (
                                    event.keyCode === 8 ||
                                    event.keyCode === 9 ||
                                    event.keyCode === 37 ||
                                    event.keyCode === 38 ||
                                    event.keyCode === 39 ||
                                    event.keyCode === 40 ||
                                    event.keyCode === 18 ||
                                    event.keyCode === 17 ||
                                    event.ctrlKey
                                  )
                                    return;

                                  if (
                                    field?.patternAllowed &&
                                    !field?.patternAllowed.test(event.key)
                                  ) {
                                    event.preventDefault();
                                  } else if (
                                    field?.patternAllowed &&
                                    !field?.patternAllowed.test(
                                      event.target.value + event.key,
                                    )
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                {...{
                                  ...field,
                                  variant: "outlined", // Adding this variant prop
                                  isNonMarginTop: true,
                                  value: estimateForm?.[field?.id],
                                  disabled: disabledField,
                                  inSingleGridForm: true,
                                  lblBackgroundColor:
                                    estimateForm?.requirements?.some(
                                      (req: any) =>
                                        req.service_name === "insurance" &&
                                        req.is_accepted,
                                    )
                                      ? "#008E72"
                                      : "#E3FCEF",
                                  InputProps: {
                                    ...(field?.inputProps && field?.inputProps),
                                    autocomplete: "off",
                                    sx: {
                                      padding: "2px 4px",
                                      height: "36px",
                                    },
                                  },
                                  onChange: (e: any) =>
                                    onChangeAction(
                                      e,
                                      "generalInfo",
                                      0,
                                      field?.valueFormat,
                                    ),
                                  onBlur: onBlurAction,
                                }}
                              />
                            );
                          },
                        )}
                      </>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{ display: "flex", justifyContent: "start" }}
                  >
                    {leadEstimateInsuranceFields.map(
                      (field: any, idx: number) => {
                        return (
                          <FormField
                            key={idx}
                            onPaste={(
                              e: React.ClipboardEvent<HTMLInputElement>,
                            ) => e.preventDefault()}
                            onKeyDown={(event: any) => {
                              if (
                                event.keyCode === 8 ||
                                event.keyCode === 9 ||
                                event.keyCode === 37 ||
                                event.keyCode === 38 ||
                                event.keyCode === 39 ||
                                event.keyCode === 40 ||
                                event.keyCode === 18 ||
                                event.keyCode === 17 ||
                                event.ctrlKey
                              )
                                return;

                              if (
                                field?.patternAllowed &&
                                !field?.patternAllowed.test(event.key)
                              ) {
                                event.preventDefault();
                              } else if (
                                field?.patternAllowed &&
                                !field?.patternAllowed.test(
                                  event.target.value + event.key,
                                )
                              ) {
                                event.preventDefault();
                              }
                            }}
                            {...{
                              ...field,
                              type: field?.type,
                              variant: "outlined", // Adding this variant prop
                              isNonMarginTop: true,
                              value: (() => {
                                if (field?.id === "insuranceType") {
                                  // Try to find by name first, then by id
                                  if (estimateForm?.insuranceType) {
                                    const type =
                                      sales?.insurance_extended_liability_types?.find(
                                        (t: any) =>
                                          t.name === estimateForm.insuranceType,
                                      );
                                    return type
                                      ? type.id
                                      : estimateForm.insuranceType;
                                  }
                                  if (estimateForm?.insurance_type_id) {
                                    return estimateForm.insurance_type_id;
                                  }
                                  return "";
                                }
                                return estimateForm?.[field?.id];
                              })(),
                              options:
                                sales?.insurance_extended_liability_types ?? [],
                              disabled: disabledField,
                              inSingleGridForm: true,
                              GridFieldStyle: {
                                marginRight: "8px",
                              },
                              InputProps: {
                                ...field?.inputProps,
                                autocomplete: "off",
                                sx: {
                                  padding: "2px 4px",
                                  height: "36px",
                                },
                              },
                              onChange: (e: any) =>
                                onChangeAction(
                                  e,
                                  "generalInfo",
                                  0,
                                  field?.valueFormat,
                                ),
                              onBlur: onBlurAction,
                            }}
                          />
                        );
                      },
                    )}
                  </Grid>
                </Grid>
              </>
            )}
            {/* final field */}
            <div
              style={{
                padding: "10px 10px 0 10px",
              }}
            >
              <Grid container spacing={1}>
                {(screenType !== "quotation"
                  ? leadEstimateNewFinalFields
                  : leadEstimateFinalFields
                )
                  // : getLeadEstimateFinalFields({ hideQuoteTotal: estimateForm?.hidequotetotal })
                  .map((field: any, idx: number) => {
                    // special case for type === "title"
                    if (field.type === "title") {
                      return (
                        <Grid
                          key={idx}
                          item
                          xs={12}
                          sm={field.md || 1.5}
                          className={classes.labelBox}
                          sx={{
                            margin: "10!important",
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "10px !important",
                          }}
                        >
                          <InputLabel
                            sx={{
                              color: "#333333",
                              fontWeight: 600,
                              fontSize: "18px",
                              textWrap: "wrap",
                              lineHeight: 1.1,
                            }}
                            shrink
                          >
                            {field.label}
                          </InputLabel>
                        </Grid>
                      );
                    }

                    // default input field
                    return (
                      <FormField
                        key={`${field.id}-${activeTab}`}
                        onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                          e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (
                            event.keyCode === 8 ||
                            event.keyCode === 9 ||
                            event.keyCode === 37 ||
                            event.keyCode === 38 ||
                            event.keyCode === 39 ||
                            event.keyCode === 40 ||
                            event.keyCode === 18 ||
                            event.keyCode === 17 ||
                            event.ctrlKey
                          )
                            return;

                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          } else if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(
                              event.target.value + event.key,
                            )
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...field,
                          id: field?.id,
                          label:
                            field?.label?.[
                              screenType === "quotation"
                                ? "quotation"
                                : "estimate"
                            ],
                          variant: "outlined", // Adding this variant prop
                          // value: field?.id ==='quoteExpiresOn' ? screenType === "quotation"
                          // ? dayjs().add(3, "months")
                          // : ""
                          value:
                            field?.id === "quoteTotal" ||
                            field?.id === "costTotal"
                              ? Number(
                                  estimateForm?.[field.id] ?? 0,
                                ).toLocaleString("en-GB")
                              : field?.id === "profit"
                                ? calculateProfit(
                                    estimateForm?.quoteTotal,
                                    estimateForm?.costTotal,
                                  )
                                : (estimateForm?.[field.id] ?? ""),
                          isNonMarginTop: true,
                          disabled:
                            field?.id === "quoteExpiresOn"
                              ? isTesterSection || disabledField
                              : field?.disabled || disabledField,
                          GridFieldStyle: {
                            ...field?.GridFieldStyle,
                            paddingLeft:
                              field?.id === "quoteTotal" ||
                              field?.id === "contentValue"
                                ? "0px !important"
                                : field?.id === "costTotal" ||
                                    field?.id === "profit" ||
                                    field?.id === "accepted_status"
                                  ? "5px !important"
                                  : "0px !important",
                          },
                          InputProps: {
                            ...field?.inputProps,
                            sx: {
                              // ...field?.inputProps?.sx,
                              padding: "2px 4px",
                              height: "36px",
                            },
                          },
                          onChange: onChangeAction,
                          onBlur: onBlurAction,
                          error: error && error?.[field?.id],
                        }}
                      />
                    );
                  })}
                {/* profile section */}
                {Number(sales?.minimum_profit_level) >
                  calculateProfit(
                    estimateForm?.quoteTotal,
                    estimateForm?.costTotal,
                  ) && (
                  <Grid item xs={6}>
                    <Alert
                      severity="warning"
                      sx={{ padding: "4px 10px", marginTop: "12px" }}
                    >
                      Warning: Profit is below the minimum profit level
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </div>
          </Grid>
          {/* notes section */}
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              marginTop: "10px", //
              padding: "6px 10px 10px 10px !important",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #ddd",
            }}
          >
            <Grid container spacing={1}>
              {leadQuoteNoteFields.map((field: any, idx: number) => {
                return (
                  <FormField
                    // key={field.id}
                    // onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    //   e.preventDefault()
                    // }
                    {...{
                      ...field,
                      id: field?.id,
                      variant: "outlined", // Adding this variant prop
                      isNonMarginTop: true,
                      value: estimateForm ? estimateForm[field.id] : "",
                      editReadOnly: field?.disabled || disabledField,
                      InputProps: {
                        ...field?.inputProps,
                        sx: {
                          // ...field?.inputProps?.sx,
                          padding: "2px 4px",
                          height: "36px",
                          resize: "none",
                        },
                        style: {
                          borderRadius: "25px",
                        }, // Adjust padding for all input types
                      },
                      InputLabelProps: {
                        sx: {
                          whiteSpace: "normal",
                          lineHeight: 1,
                          marginTop: "10px",
                        },
                      },
                      GridFieldStyle: {
                        ...field?.GridFieldStyle,
                        marginLeft: "-16px !important",
                      },
                      onChange: onChangeAction,
                      onBlur: onBlurAction,
                      error: error && error?.[field?.id],
                    }}
                  />
                );
              })}
            </Grid>
          </Grid>
          <div
            style={{
              position: "fixed",
              borderTop: "1px solid #CCC",
              left: 100,
              bottom: 48,
              right: 100,
              background: "#FFF",
              // display: "flex",
              // justifyContent: "space-between",
              padding: "10px 20px",
              zIndex: 1,
              border: "2px solid #CCC",
              boxShadow: "0 4px 6px -2px rgba(0,0,0,0.2)",
              borderBottomLeftRadius: "5px",
              borderBottomRightRadius: "5px",
            }}
          >
            <div style={{ paddingLeft: "19px" }}>
              {/* <CustomButton
              style={{ marginRight: "10px" }}
              title="Save"
              disabled={disabledField || leadDetails?.lead?.status === "JOB"}
              onClick={() => submitHandler()}
            /> */}

              <QuoteActions
                estimateForm={estimateForm}
                screenType={screenType}
                isShowActionCalled={isShowActionCalled}
                setIsShowActionCalled={setIsShowActionCalled}
                setIsFieldValueChanged={setIsFieldValueChanged}
                isFieldValueChanged={isFieldValueChanged}
                disabledField={disabledField}
                activeTab={activeTab}
                quoteId={estimateForm?.quoteId}
                handleDuplicateTab={handleDuplicateTab}
              />
              {/* <CustomButton
              title="Return"
              onClick={() => {
                setShow(false);
                setEstimateForm(null);
                setError(null);
              }}
            /> */}
              {(selectedLeadQuote || load) && screenType === "quotation" && (
                <FormControlLabel
                  label="VAT Included"
                  labelPlacement="start"
                  control={
                    <Checkbox
                      sx={{
                        marginTop: "0",
                        marginLeft: "0 !important",
                        width: "auto !important",
                      }}
                      checked={estimateForm?.vatIncluded}
                      disabled={disabledField}
                      onChange={(e: any) => onChangeAction(e)}
                      name="vatIncluded"
                      id="vatIncluded"
                      color="primary"
                    />
                  }
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "13px", // Set your desired font size here
                      display: "flex",
                    },
                  }}
                />
              )}
            </div>
          </div>
        </Grid>
        {/* Confirmation Dialog for unsaved changes when creating new quote */}
        {showNewQuoteConfirmDialog && (
          <AlertPopup
            open={showNewQuoteConfirmDialog}
            onHide={() => setShowNewQuoteConfirmDialog(false)}
            submitHandler={confirmAbandonChangesAndCreateNew}
            title="Unsaved Changes"
            content="Do you wish to abandon your changes?"
          />
        )}

        {/* Confirmation Dialog for unsaved changes when closing */}
        {showCloseConfirmDialog && (
          <AlertPopup
            open={showCloseConfirmDialog}
            onHide={() => setShowCloseConfirmDialog(false)}
            submitHandler={confirmAbandonChangesAndClose}
            title="Unsaved Changes"
            content="Do you wish to abandon your changes?"
          />
        )}

        {/* Confirmation Dialog for tab deletion */}
        {showDeleteConfirmDialog && (
          <AlertPopup
            open={showDeleteConfirmDialog}
            onHide={() => {
              setShowDeleteConfirmDialog(false);
              setTabToDelete(null);
            }}
            submitHandler={confirmDeleteTab}
            title="Alert"
            content={
              tabToDelete !== null &&
              (quoteTabs[tabToDelete]?.data as any)?.quoteId
                ? // ? "Are you sure you want to delete this quote? This action will permanently remove the quote from the system."
                  "Are you sure you want to delete this quote?"
                : "Are you sure you want to remove this tab?"
            }
          />
        )}

        {/* AlertMessage for accepted quote deletion */}
        {showAcceptedQuoteAlert && (
          <AlertMessage
            open={showAcceptedQuoteAlert}
            onHide={() => {
              setShowAcceptedQuoteAlert(false);
              setTabToDelete(null);
            }}
            title="Alert"
            content="Accepted quotes cannot be deleted."
          />
        )}
      </div>
    </>
  );
};

export default LeadQuoteForm;
